import "./main.css";
import { createVuetify as Xl } from "vuetify";
import { Fragment as Z, reactive as ct, computed as y, watchEffect as Pe, toRefs as Tn, capitalize as Dn, getCurrentInstance as Rn, inject as X, ref as A, unref as be, provide as re, watch as H, effectScope as dt, onScopeDispose as se, shallowRef as Zl, shallowReactive as Jl, toRaw as Ql, defineComponent as Nn, camelize as Mn, h as Ge, TransitionGroup as ea, Transition as Ce, createVNode as s, mergeProps as M, isRef as Ae, toRef as j, onBeforeUnmount as _e, withDirectives as Q, vShow as Oe, onBeforeMount as zn, onMounted as Ue, resolveDirective as we, cloneVNode as ta, nextTick as ee, resolveDynamicComponent as na, readonly as la, warn as aa, toHandlers as kt, Teleport as oa, vModelText as ia, createTextVNode as Hn } from "vue";
function jn(e, t, n) {
  const l = t.length - 1;
  if (l < 0)
    return e === void 0 ? n : e;
  for (let a = 0; a < l; a++) {
    if (e == null)
      return n;
    e = e[t[a]];
  }
  return e == null || e[t[l]] === void 0 ? n : e[t[l]];
}
function Ke(e, t) {
  if (e === t)
    return !0;
  if (e instanceof Date && t instanceof Date && e.getTime() !== t.getTime() || e !== Object(e) || t !== Object(t))
    return !1;
  const n = Object.keys(e);
  return n.length !== Object.keys(t).length ? !1 : n.every((l) => Ke(e[l], t[l]));
}
function ra(e, t, n) {
  return e == null || !t || typeof t != "string" ? n : e[t] !== void 0 ? e[t] : (t = t.replace(/\[(\w+)\]/g, ".$1"), t = t.replace(/^\./, ""), jn(e, t.split("."), n));
}
function de(e, t, n) {
  if (t == null)
    return e === void 0 ? n : e;
  if (e !== Object(e)) {
    if (typeof t != "function")
      return n;
    const a = t(e, n);
    return typeof a > "u" ? n : a;
  }
  if (typeof t == "string")
    return ra(e, t, n);
  if (Array.isArray(t))
    return jn(e, t, n);
  if (typeof t != "function")
    return n;
  const l = t(e, n);
  return typeof l > "u" ? n : l;
}
function z(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "px";
  if (!(e == null || e === ""))
    return isNaN(+e) ? String(e) : isFinite(+e) ? `${Number(e)}${t}` : void 0;
}
function Et(e) {
  return e !== null && typeof e == "object" && !Array.isArray(e);
}
function sa(e) {
  return e == null ? void 0 : e.$el;
}
const hn = Object.freeze({
  enter: 13,
  tab: 9,
  delete: 46,
  esc: 27,
  space: 32,
  up: 38,
  down: 40,
  left: 37,
  right: 39,
  end: 35,
  home: 36,
  del: 46,
  backspace: 8,
  insert: 45,
  pageup: 33,
  pagedown: 34,
  shift: 16
});
function fe(e, t) {
  const n = /* @__PURE__ */ Object.create(null), l = /* @__PURE__ */ Object.create(null);
  for (const a in e)
    t.some((o) => o instanceof RegExp ? o.test(a) : o === a) ? n[a] = e[a] : l[a] = e[a];
  return [n, l];
}
function qe(e, t) {
  const n = {
    ...e
  };
  return t.forEach((l) => delete n[l]), n;
}
function Ye(e) {
  return fe(e, ["class", "style", "id", /^data-/]);
}
function ve(e) {
  return e == null ? [] : Array.isArray(e) ? e : [e];
}
function Bt(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  return Math.max(t, Math.min(n, e));
}
function lt() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0;
  const l = {};
  for (const a in e)
    l[a] = e[a];
  for (const a in t) {
    const o = e[a], i = t[a];
    if (Et(o) && Et(i)) {
      l[a] = lt(o, i, n);
      continue;
    }
    if (Array.isArray(o) && Array.isArray(i) && n) {
      l[a] = n(o, i);
      continue;
    }
    l[a] = i;
  }
  return l;
}
function Wn(e) {
  return e.map((t) => t.type === Z ? Wn(t.children) : t).flat();
}
function vt() {
  return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "").replace(/[^a-z]/gi, "-").replace(/\B([A-Z])/g, "-$1").toLowerCase();
}
function tt(e, t) {
  if (!t || typeof t != "object")
    return [];
  if (Array.isArray(t))
    return t.map((n) => tt(e, n)).flat(1);
  if (Array.isArray(t.children))
    return t.children.map((n) => tt(e, n)).flat(1);
  if (t.component) {
    if (Object.getOwnPropertySymbols(t.component.provides).includes(e))
      return [t.component];
    if (t.component.subTree)
      return tt(e, t.component.subTree).flat(1);
  }
  return [];
}
function jt(e) {
  const t = ct({}), n = y(e);
  return Pe(() => {
    for (const l in n.value)
      t[l] = n.value[l];
  }, {
    flush: "sync"
  }), Tn(t);
}
function at(e, t) {
  return e.includes(t);
}
const ua = /^on[^a-z]/, Gn = (e) => ua.test(e), Se = [Function, Array];
function pn(e, t) {
  return t = "on" + Dn(t), !!(e[t] || e[`${t}Once`] || e[`${t}Capture`] || e[`${t}OnceCapture`] || e[`${t}CaptureOnce`]);
}
function Un(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), l = 1; l < t; l++)
    n[l - 1] = arguments[l];
  if (Array.isArray(e))
    for (const a of e)
      a(...n);
  else
    typeof e == "function" && e(...n);
}
const Kn = ["top", "bottom"], ca = ["start", "end", "left", "right"];
function Lt(e, t) {
  let [n, l] = e.split(" ");
  return l || (l = at(Kn, n) ? "start" : at(ca, n) ? "top" : "center"), {
    side: bn(n, t),
    align: bn(l, t)
  };
}
function bn(e, t) {
  return e === "start" ? t ? "right" : "left" : e === "end" ? t ? "left" : "right" : e;
}
function xt(e) {
  return {
    side: {
      center: "center",
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    }[e.side],
    align: e.align
  };
}
function Vt(e) {
  return {
    side: e.side,
    align: {
      center: "center",
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    }[e.align]
  };
}
function Sn(e) {
  return {
    side: e.align,
    align: e.side
  };
}
function Cn(e) {
  return at(Kn, e.side) ? "y" : "x";
}
class xe {
  constructor(t) {
    let {
      x: n,
      y: l,
      width: a,
      height: o
    } = t;
    this.x = n, this.y = l, this.width = a, this.height = o;
  }
  get top() {
    return this.y;
  }
  get bottom() {
    return this.y + this.height;
  }
  get left() {
    return this.x;
  }
  get right() {
    return this.x + this.width;
  }
}
function _n(e, t) {
  return {
    x: {
      before: Math.max(0, t.left - e.left),
      after: Math.max(0, e.right - t.right)
    },
    y: {
      before: Math.max(0, t.top - e.top),
      after: Math.max(0, e.bottom - t.bottom)
    }
  };
}
function Wt(e) {
  const t = e.getBoundingClientRect(), n = getComputedStyle(e), l = n.transform;
  if (l) {
    let a, o, i, r, c;
    if (l.startsWith("matrix3d("))
      a = l.slice(9, -1).split(/, /), o = +a[0], i = +a[5], r = +a[12], c = +a[13];
    else if (l.startsWith("matrix("))
      a = l.slice(7, -1).split(/, /), o = +a[0], i = +a[3], r = +a[4], c = +a[5];
    else
      return new xe(t);
    const v = n.transformOrigin, f = t.x - r - (1 - o) * parseFloat(v), d = t.y - c - (1 - i) * parseFloat(v.slice(v.indexOf(" ") + 1)), u = o ? t.width / o : e.offsetWidth + 1, m = i ? t.height / i : e.offsetHeight + 1;
    return new xe({
      x: f,
      y: d,
      width: u,
      height: m
    });
  } else
    return new xe(t);
}
function ke(e, t, n) {
  if (typeof e.animate > "u")
    return {
      finished: Promise.resolve()
    };
  const l = e.animate(t, n);
  return typeof l.finished > "u" && (l.finished = new Promise((a) => {
    l.onfinish = () => {
      a(l);
    };
  })), l;
}
function qn(e, t, n) {
  if (n && (t = {
    __isVue: !0,
    $parent: n,
    $options: t
  }), t) {
    if (t.$_alreadyWarned = t.$_alreadyWarned || [], t.$_alreadyWarned.includes(e))
      return;
    t.$_alreadyWarned.push(e);
  }
  return `[Vuetify] ${e}` + (t ? ma(t) : "");
}
function Yn(e, t, n) {
  const l = qn(e, t, n);
  l != null && console.warn(l);
}
function da(e, t, n) {
  const l = qn(e, t, n);
  l != null && console.error(l);
}
const va = /(?:^|[-_])(\w)/g, fa = (e) => e.replace(va, (t) => t.toUpperCase()).replace(/[-_]/g, "");
function $t(e, t) {
  if (e.$root === e)
    return "<Root>";
  const n = typeof e == "function" && e.cid != null ? e.options : e.__isVue ? e.$options || e.constructor.options : e || {};
  let l = n.name || n._componentTag;
  const a = n.__file;
  if (!l && a) {
    const o = a.match(/([^/\\]+)\.vue$/);
    l = o == null ? void 0 : o[1];
  }
  return (l ? `<${fa(l)}>` : "<Anonymous>") + (a && t !== !1 ? ` at ${a}` : "");
}
function ma(e) {
  if (e.__isVue && e.$parent) {
    const t = [];
    let n = 0;
    for (; e; ) {
      if (t.length > 0) {
        const l = t[t.length - 1];
        if (l.constructor === e.constructor) {
          n++, e = e.$parent;
          continue;
        } else
          n > 0 && (t[t.length - 1] = [l, n], n = 0);
      }
      t.push(e), e = e.$parent;
    }
    return `

found in

` + t.map((l, a) => `${a === 0 ? "---> " : " ".repeat(5 + a * 2)}${Array.isArray(l) ? `${$t(l[0])}... (${l[1]} recursive calls)` : $t(l)}`).join(`
`);
  } else
    return `

(found in ${$t(e)})`;
}
function wn(e) {
  return !!e && /^(#|var\(--|(rgb|hsl)a?\()/.test(e);
}
function te(e, t) {
  const n = Rn();
  if (!n)
    throw new Error(`[Vuetify] ${e} ${t || "must be called from inside a setup function"}`);
  return n;
}
function ge() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "composables";
  const t = te(e).type;
  return vt((t == null ? void 0 : t.aliasName) || (t == null ? void 0 : t.name));
}
let Xn = 0, nt = /* @__PURE__ */ new WeakMap();
function ue() {
  const e = te("getUid");
  if (nt.has(e))
    return nt.get(e);
  {
    const t = Xn++;
    return nt.set(e, t), t;
  }
}
ue.reset = () => {
  Xn = 0, nt = /* @__PURE__ */ new WeakMap();
};
function ga(e) {
  const {
    provides: t
  } = te("injectSelf");
  if (t && e in t)
    return t[e];
}
const Gt = Symbol.for("vuetify:defaults");
function Zn() {
  const e = X(Gt);
  if (!e)
    throw new Error("[Vuetify] Could not find defaults instance");
  return e;
}
function Xe(e, t) {
  const n = Zn(), l = A(e), a = y(() => {
    const o = be(t == null ? void 0 : t.scoped), i = be(t == null ? void 0 : t.reset), r = be(t == null ? void 0 : t.root);
    let c = lt(l.value, {
      prev: n.value
    });
    if (o)
      return c;
    if (i || r) {
      const v = Number(i || 1 / 0);
      for (let f = 0; f <= v && c.prev; f++)
        c = c.prev;
      return c;
    }
    return lt(c.prev, c);
  });
  return re(Gt, a), a;
}
function Ve(e, t) {
  let n;
  H(e, (l) => {
    if (l && !n)
      n = dt(), n.run(t);
    else if (!l) {
      var a;
      (a = n) == null || a.stop(), n = void 0;
    }
  }, {
    immediate: !0
  }), se(() => {
    var l;
    (l = n) == null || l.stop();
  });
}
function R(e, t) {
  return (n) => Object.keys(e).reduce((l, a) => {
    const i = typeof e[a] == "object" && e[a] != null && !Array.isArray(e[a]) ? e[a] : {
      type: e[a]
    };
    return n && a in n ? l[a] = {
      ...i,
      default: n[a]
    } : l[a] = i, t && !l[a].source && (l[a].source = t), l;
  }, {});
}
function ya(e, t) {
  var n, l;
  return ((n = e.props) == null ? void 0 : n.hasOwnProperty(t)) || ((l = e.props) == null ? void 0 : l.hasOwnProperty(vt(t)));
}
const G = function(t) {
  return t._setup = t._setup ?? t.setup, t.name ? (t._setup && (t.props = t.props ?? {}, t.props = R(t.props, vt(t.name))(), t.props._as = String, t.setup = function(l, a) {
    const o = Rn(), i = Zn(), r = Zl(), c = Jl({
      ...Ql(l)
    });
    Pe(() => {
      const f = i.value.global, d = i.value[l._as ?? t.name];
      if (d) {
        const u = Object.entries(d).filter((m) => {
          let [p] = m;
          return p.startsWith(p[0].toUpperCase());
        });
        u.length && (r.value = Object.fromEntries(u));
      }
      for (const u of Object.keys(l)) {
        let m = l[u];
        ya(o.vnode, u) || (m = (d == null ? void 0 : d[u]) ?? (f == null ? void 0 : f[u]) ?? l[u]), c[u] !== m && (c[u] = m);
      }
    });
    const v = t._setup(c, a);
    return Ve(r, () => {
      var f;
      Xe(lt(((f = ga(Gt)) == null ? void 0 : f.value) ?? {}, r.value));
    }), v;
  }), t) : (Yn("The component is missing an explicit name, unable to generate default prop value"), t);
};
function ne() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
  return (t) => (e ? G : Nn)(t);
}
function Jn(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "div", n = arguments.length > 2 ? arguments[2] : void 0;
  return G({
    name: n ?? Dn(Mn(e.replace(/__/g, "-"))),
    props: {
      tag: {
        type: String,
        default: t
      }
    },
    setup(l, a) {
      let {
        slots: o
      } = a;
      return () => {
        var i;
        return Ge(l.tag, {
          class: e
        }, (i = o.default) == null ? void 0 : i.call(o));
      };
    }
  });
}
function Qn(e) {
  if (typeof e.getRootNode != "function") {
    for (; e.parentNode; )
      e = e.parentNode;
    return e !== document ? null : document;
  }
  const t = e.getRootNode();
  return t !== document && t.getRootNode({
    composed: !0
  }) !== document ? null : t;
}
const ot = "cubic-bezier(0.4, 0, 0.2, 1)", ha = "cubic-bezier(0.0, 0, 0.2, 1)", pa = "cubic-bezier(0.4, 0, 1, 1)";
function ba(e) {
  for (; e; ) {
    if (Ut(e))
      return e;
    e = e.parentElement;
  }
  return document.scrollingElement;
}
function it(e, t) {
  const n = [];
  if (t && e && !t.contains(e))
    return n;
  for (; e && (Ut(e) && n.push(e), e !== t); )
    e = e.parentElement;
  return n;
}
function Ut(e) {
  if (!e || e.nodeType !== Node.ELEMENT_NODE)
    return !1;
  const t = window.getComputedStyle(e);
  return t.overflowY === "scroll" || t.overflowY === "auto" && e.scrollHeight > e.clientHeight;
}
const oe = typeof window < "u", Kt = oe && "IntersectionObserver" in window, Ft = oe && typeof CSS < "u" && CSS.supports("selector(:focus-visible)");
function Sa(e) {
  for (; e; ) {
    if (window.getComputedStyle(e).position === "fixed")
      return !0;
    e = e.offsetParent;
  }
  return !1;
}
function W(e) {
  const t = te("useRender");
  t.render = e;
}
function le(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "top center 0", n = arguments.length > 2 ? arguments[2] : void 0;
  return G({
    name: e,
    props: {
      group: Boolean,
      hideOnLeave: Boolean,
      leaveAbsolute: Boolean,
      mode: {
        type: String,
        default: n
      },
      origin: {
        type: String,
        default: t
      }
    },
    setup(l, a) {
      let {
        slots: o
      } = a;
      return () => {
        const i = l.group ? ea : Ce;
        return Ge(i, {
          name: e,
          mode: l.mode,
          onBeforeEnter(r) {
            r.style.transformOrigin = l.origin;
          },
          onLeave(r) {
            if (l.leaveAbsolute) {
              const {
                offsetTop: c,
                offsetLeft: v,
                offsetWidth: f,
                offsetHeight: d
              } = r;
              r._transitionInitialStyles = {
                position: r.style.position,
                top: r.style.top,
                left: r.style.left,
                width: r.style.width,
                height: r.style.height
              }, r.style.position = "absolute", r.style.top = `${c}px`, r.style.left = `${v}px`, r.style.width = `${f}px`, r.style.height = `${d}px`;
            }
            l.hideOnLeave && r.style.setProperty("display", "none", "important");
          },
          onAfterLeave(r) {
            if (l.leaveAbsolute && r != null && r._transitionInitialStyles) {
              const {
                position: c,
                top: v,
                left: f,
                width: d,
                height: u
              } = r._transitionInitialStyles;
              delete r._transitionInitialStyles, r.style.position = c || "", r.style.top = v || "", r.style.left = f || "", r.style.width = d || "", r.style.height = u || "";
            }
          }
        }, o.default);
      };
    }
  });
}
function el(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "in-out";
  return G({
    name: e,
    props: {
      mode: {
        type: String,
        default: n
      }
    },
    setup(l, a) {
      let {
        slots: o
      } = a;
      return () => Ge(Ce, {
        name: e,
        // mode: props.mode, // TODO: vuejs/vue-next#3104
        ...t
      }, o.default);
    }
  });
}
function tl() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  const n = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1) ? "width" : "height", l = Mn(`offset-${n}`);
  return {
    onBeforeEnter(i) {
      i._parent = i.parentNode, i._initialStyle = {
        transition: i.style.transition,
        overflow: i.style.overflow,
        [n]: i.style[n]
      };
    },
    onEnter(i) {
      const r = i._initialStyle;
      i.style.setProperty("transition", "none", "important"), i.style.overflow = "hidden";
      const c = `${i[l]}px`;
      i.style[n] = "0", i.offsetHeight, i.style.transition = r.transition, e && i._parent && i._parent.classList.add(e), requestAnimationFrame(() => {
        i.style[n] = c;
      });
    },
    onAfterEnter: o,
    onEnterCancelled: o,
    onLeave(i) {
      i._initialStyle = {
        transition: "",
        overflow: i.style.overflow,
        [n]: i.style[n]
      }, i.style.overflow = "hidden", i.style[n] = `${i[l]}px`, i.offsetHeight, requestAnimationFrame(() => i.style[n] = "0");
    },
    onAfterLeave: a,
    onLeaveCancelled: a
  };
  function a(i) {
    e && i._parent && i._parent.classList.remove(e), o(i);
  }
  function o(i) {
    const r = i._initialStyle[n];
    i.style.overflow = i._initialStyle.overflow, r != null && (i.style[n] = r), delete i._initialStyle;
  }
}
const nl = G({
  name: "VDialogTransition",
  props: {
    target: Object
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const l = {
      onBeforeEnter(a) {
        a.style.pointerEvents = "none", a.style.visibility = "hidden";
      },
      async onEnter(a, o) {
        var i;
        await new Promise((m) => requestAnimationFrame(m)), await new Promise((m) => requestAnimationFrame(m)), a.style.visibility = "";
        const {
          x: r,
          y: c,
          sx: v,
          sy: f,
          speed: d
        } = xn(e.target, a), u = ke(a, [{
          transform: `translate(${r}px, ${c}px) scale(${v}, ${f})`,
          opacity: 0
        }, {
          transform: ""
        }], {
          duration: 225 * d,
          easing: ha
        });
        (i = kn(a)) == null || i.forEach((m) => {
          ke(m, [{
            opacity: 0
          }, {
            opacity: 0,
            offset: 0.33
          }, {
            opacity: 1
          }], {
            duration: 225 * 2 * d,
            easing: ot
          });
        }), u.finished.then(() => o());
      },
      onAfterEnter(a) {
        a.style.removeProperty("pointer-events");
      },
      onBeforeLeave(a) {
        a.style.pointerEvents = "none";
      },
      async onLeave(a, o) {
        var i;
        await new Promise((m) => requestAnimationFrame(m));
        const {
          x: r,
          y: c,
          sx: v,
          sy: f,
          speed: d
        } = xn(e.target, a);
        ke(a, [{
          transform: ""
        }, {
          transform: `translate(${r}px, ${c}px) scale(${v}, ${f})`,
          opacity: 0
        }], {
          duration: 125 * d,
          easing: pa
        }).finished.then(() => o()), (i = kn(a)) == null || i.forEach((m) => {
          ke(m, [{}, {
            opacity: 0,
            offset: 0.2
          }, {
            opacity: 0
          }], {
            duration: 125 * 2 * d,
            easing: ot
          });
        });
      },
      onAfterLeave(a) {
        a.style.removeProperty("pointer-events");
      }
    };
    return () => e.target ? s(Ce, M({
      name: "dialog-transition"
    }, l, {
      css: !1
    }), n) : s(Ce, {
      name: "dialog-transition"
    }, n);
  }
});
function kn(e) {
  var t;
  const n = (t = e.querySelector(":scope > .v-card, :scope > .v-sheet, :scope > .v-list")) == null ? void 0 : t.children;
  return n && [...n];
}
function xn(e, t) {
  const n = e.getBoundingClientRect(), l = Wt(t), [a, o] = getComputedStyle(t).transformOrigin.split(" ").map((w) => parseFloat(w)), [i, r] = getComputedStyle(t).getPropertyValue("--v-overlay-anchor-origin").split(" ");
  let c = n.left + n.width / 2;
  i === "left" || r === "left" ? c -= n.width / 2 : (i === "right" || r === "right") && (c += n.width / 2);
  let v = n.top + n.height / 2;
  i === "top" || r === "top" ? v -= n.height / 2 : (i === "bottom" || r === "bottom") && (v += n.height / 2);
  const f = n.width / l.width, d = n.height / l.height, u = Math.max(1, f, d), m = f / u || 0, p = d / u || 0, g = l.width * l.height / (window.innerWidth * window.innerHeight), b = g > 0.12 ? Math.min(1.5, (g - 0.12) * 10 + 1) : 1;
  return {
    x: c - (a + l.left),
    y: v - (o + l.top),
    sx: m,
    sy: p,
    speed: b
  };
}
le("fab-transition", "center center", "out-in");
le("dialog-bottom-transition");
le("dialog-top-transition");
le("fade-transition");
le("scale-transition");
le("scroll-x-transition");
le("scroll-x-reverse-transition");
le("scroll-y-transition");
le("scroll-y-reverse-transition");
le("slide-x-transition");
le("slide-x-reverse-transition");
const ll = le("slide-y-transition");
le("slide-y-reverse-transition");
const Ca = el("expand-transition", tl()), al = el("expand-x-transition", tl("", !0));
const K = [String, Function, Object], _a = Symbol.for("vuetify:icons"), ft = R({
  icon: {
    type: K,
    required: !0
  },
  // Could not remove this and use makeTagProps, types complained because it is not required
  tag: {
    type: String,
    required: !0
  }
}, "icon"), wa = G({
  name: "VComponentIcon",
  props: ft(),
  setup(e) {
    return () => s(e.tag, null, {
      default: () => [s(e.icon, null, null)]
    });
  }
});
G({
  name: "VSvgIcon",
  inheritAttrs: !1,
  props: ft(),
  setup(e, t) {
    let {
      attrs: n
    } = t;
    return () => s(e.tag, M(n, {
      style: null
    }), {
      default: () => [s("svg", {
        class: "v-icon__svg",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        role: "img",
        "aria-hidden": "true"
      }, [s("path", {
        d: e.icon
      }, null)])]
    });
  }
});
const ka = G({
  name: "VLigatureIcon",
  props: ft(),
  setup(e) {
    return () => s(e.tag, null, {
      default: () => [e.icon]
    });
  }
});
G({
  name: "VClassIcon",
  props: ft(),
  setup(e) {
    return () => s(e.tag, {
      class: e.icon
    }, null);
  }
});
const xa = (e) => {
  const t = X(_a);
  if (!t)
    throw new Error("Missing Vuetify Icons provide!");
  return {
    iconData: y(() => {
      const l = Ae(e) ? e.value : e.icon;
      if (!l)
        throw new Error("Icon value is undefined or null");
      let a = l;
      if (typeof a == "string" && (a = a.trim(), a.startsWith("$"))) {
        var o;
        a = (o = t.aliases) == null ? void 0 : o[a.slice(1)];
      }
      if (!a)
        throw new Error(`Could not find aliased icon "${l}"`);
      if (typeof a != "string")
        return {
          component: wa,
          icon: a
        };
      const i = Object.keys(t.sets).find((v) => typeof a == "string" && a.startsWith(`${v}:`)), r = i ? a.slice(i.length + 1) : a;
      return {
        component: t.sets[i ?? t.defaultSet].component,
        icon: r
      };
    })
  };
}, Va = ["x-small", "small", "default", "large", "x-large"], qt = R({
  size: {
    type: [String, Number],
    default: "default"
  }
}, "size");
function Yt(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ge();
  return jt(() => {
    let n, l;
    return at(Va, e.size) ? n = `${t}--size-${e.size}` : e.size && (l = {
      width: z(e.size),
      height: z(e.size)
    }), {
      sizeClasses: n,
      sizeStyles: l
    };
  });
}
const ye = R({
  tag: {
    type: String,
    default: "div"
  }
}, "tag"), Vn = Symbol.for("vuetify:theme"), ae = R({
  theme: String
}, "theme");
function ce(e) {
  te("provideTheme");
  const t = X(Vn, null);
  if (!t)
    throw new Error("Could not find Vuetify theme injection");
  const n = y(() => e.theme ?? (t == null ? void 0 : t.name.value)), l = y(() => t.isDisabled ? void 0 : `v-theme--${n.value}`), a = {
    ...t,
    name: n,
    themeClasses: l
  };
  return re(Vn, a), a;
}
function Xt(e) {
  return jt(() => {
    const t = [], n = {};
    return e.value.background && (wn(e.value.background) ? n.backgroundColor = e.value.background : t.push(`bg-${e.value.background}`)), e.value.text && (wn(e.value.text) ? (n.color = e.value.text, n.caretColor = e.value.text) : t.push(`text-${e.value.text}`)), {
      colorClasses: t,
      colorStyles: n
    };
  });
}
function Ee(e, t) {
  const n = y(() => ({
    text: Ae(e) ? e.value : t ? e[t] : null
  })), {
    colorClasses: l,
    colorStyles: a
  } = Xt(n);
  return {
    textColorClasses: l,
    textColorStyles: a
  };
}
function $e(e, t) {
  const n = y(() => ({
    background: Ae(e) ? e.value : t ? e[t] : null
  })), {
    colorClasses: l,
    colorStyles: a
  } = Xt(n);
  return {
    backgroundColorClasses: l,
    backgroundColorStyles: a
  };
}
const $a = R({
  color: String,
  start: Boolean,
  end: Boolean,
  icon: K,
  ...qt(),
  ...ye({
    tag: "i"
  }),
  ...ae()
}, "v-icon"), me = G({
  name: "VIcon",
  props: $a(),
  setup(e, t) {
    let {
      attrs: n,
      slots: l
    } = t, a;
    l.default && (a = y(() => {
      var f, d;
      const u = (f = l.default) == null ? void 0 : f.call(l);
      if (u)
        return (d = Wn(u).filter((m) => m.children && typeof m.children == "string")[0]) == null ? void 0 : d.children;
    }));
    const {
      themeClasses: o
    } = ce(e), {
      iconData: i
    } = xa(a || e), {
      sizeClasses: r
    } = Yt(e), {
      textColorClasses: c,
      textColorStyles: v
    } = Ee(j(e, "color"));
    return W(() => s(i.value.component, {
      tag: e.tag,
      icon: i.value.icon,
      class: ["v-icon", "notranslate", o.value, r.value, c.value, {
        "v-icon--clickable": !!n.onClick,
        "v-icon--start": e.start,
        "v-icon--end": e.end
      }],
      style: [r.value ? void 0 : {
        fontSize: z(e.size),
        height: z(e.size),
        width: z(e.size)
      }, v.value],
      role: n.onClick ? "button" : void 0,
      "aria-hidden": !n.onClick
    }, null)), {};
  }
});
function q(e, t, n) {
  let l = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (d) => d, a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : (d) => d;
  const o = te("useProxiedModel"), i = A(e[t] !== void 0 ? e[t] : n), r = vt(t), v = r !== t ? y(() => {
    var d, u, m, p;
    return e[t], !!(((d = o.vnode.props) != null && d.hasOwnProperty(t) || (u = o.vnode.props) != null && u.hasOwnProperty(r)) && ((m = o.vnode.props) != null && m.hasOwnProperty(`onUpdate:${t}`) || (p = o.vnode.props) != null && p.hasOwnProperty(`onUpdate:${r}`)));
  }) : y(() => {
    var d, u;
    return e[t], !!((d = o.vnode.props) != null && d.hasOwnProperty(t) && (u = o.vnode.props) != null && u.hasOwnProperty(`onUpdate:${t}`));
  });
  Ve(() => !v.value, () => {
    H(() => e[t], (d) => {
      i.value = d;
    });
  });
  const f = y({
    get() {
      return l(v.value ? e[t] : i.value);
    },
    set(d) {
      const u = a(d);
      (v.value ? e[t] : i.value) === u || l(v.value ? e[t] : i.value) === d || (i.value = u, o == null || o.emit(`update:${t}`, u));
    }
  });
  return Object.defineProperty(f, "externalValue", {
    get: () => v.value ? e[t] : i.value
  }), f;
}
const ol = Symbol.for("vuetify:locale");
function Zt() {
  const e = X(ol);
  if (!e)
    throw new Error("[Vuetify] Could not find injected locale instance");
  return e;
}
function Jt() {
  const e = X(ol);
  if (!e)
    throw new Error("[Vuetify] Could not find injected rtl instance");
  return {
    isRtl: e.isRtl,
    rtlClasses: e.rtlClasses
  };
}
function il(e) {
  const {
    t
  } = Zt();
  function n(l) {
    let {
      name: a
    } = l;
    const o = {
      prepend: "prependAction",
      prependInner: "prependAction",
      append: "appendAction",
      appendInner: "appendAction",
      clear: "clear"
    }[a], i = e[`onClick:${a}`], r = i && o ? t(`$vuetify.input.${o}`, e.label ?? "") : void 0;
    return s(me, {
      icon: e[`${a}Icon`],
      "aria-label": r,
      onClick: i
    }, null);
  }
  return {
    InputIcon: n
  };
}
const Qt = G({
  name: "VLabel",
  props: {
    text: String,
    clickable: Boolean,
    ...ae()
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    return W(() => {
      var l;
      return s("label", {
        class: ["v-label", {
          "v-label--clickable": e.clickable
        }]
      }, [e.text, (l = n.default) == null ? void 0 : l.call(n)]);
    }), {};
  }
}), et = G({
  name: "VFieldLabel",
  props: {
    floating: Boolean
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    return W(() => s(Qt, {
      class: ["v-field-label", {
        "v-field-label--floating": e.floating
      }],
      "aria-hidden": e.floating || void 0
    }, n)), {};
  }
});
const Be = R({
  rounded: {
    type: [Boolean, Number, String],
    default: void 0
  }
}, "rounded");
function Le(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ge();
  return {
    roundedClasses: y(() => {
      const l = Ae(e) ? e.value : e.rounded, a = [];
      if (l === !0 || l === "")
        a.push(`${t}--rounded`);
      else if (typeof l == "string" || l === 0)
        for (const o of String(l).split(" "))
          a.push(`rounded-${o}`);
      return a;
    })
  };
}
function Ia(e) {
  const t = A(), n = A(!1);
  if (Kt) {
    const l = new IntersectionObserver((a) => {
      e == null || e(a, l), n.value = !!a.find((o) => o.isIntersecting);
    });
    _e(() => {
      l.disconnect();
    }), H(t, (a, o) => {
      o && (l.unobserve(o), n.value = !1), a && l.observe(a);
    }, {
      flush: "post"
    });
  }
  return {
    intersectionRef: t,
    isIntersecting: n
  };
}
const Pa = G({
  name: "VProgressLinear",
  props: {
    active: {
      type: Boolean,
      default: !0
    },
    bgColor: String,
    bgOpacity: [Number, String],
    bufferValue: {
      type: [Number, String],
      default: 0
    },
    clickable: Boolean,
    color: String,
    height: {
      type: [Number, String],
      default: 4
    },
    indeterminate: Boolean,
    max: {
      type: [Number, String],
      default: 100
    },
    modelValue: {
      type: [Number, String],
      default: 0
    },
    reverse: Boolean,
    stream: Boolean,
    striped: Boolean,
    roundedBar: Boolean,
    ...Be(),
    ...ye(),
    ...ae()
  },
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const l = q(e, "modelValue"), {
      isRtl: a
    } = Jt(), {
      themeClasses: o
    } = ce(e), {
      textColorClasses: i,
      textColorStyles: r
    } = Ee(e, "color"), {
      backgroundColorClasses: c,
      backgroundColorStyles: v
    } = $e(y(() => e.bgColor || e.color)), {
      backgroundColorClasses: f,
      backgroundColorStyles: d
    } = $e(e, "color"), {
      roundedClasses: u
    } = Le(e), {
      intersectionRef: m,
      isIntersecting: p
    } = Ia(), g = y(() => parseInt(e.max, 10)), b = y(() => parseInt(e.height, 10)), w = y(() => parseFloat(e.bufferValue) / g.value * 100), V = y(() => parseFloat(l.value) / g.value * 100), h = y(() => a.value !== e.reverse), I = y(() => e.indeterminate ? "fade-transition" : "slide-x-transition"), x = y(() => e.bgOpacity == null ? e.bgOpacity : parseFloat(e.bgOpacity));
    function B(P) {
      if (!m.value)
        return;
      const {
        left: S,
        right: _,
        width: C
      } = m.value.getBoundingClientRect(), k = h.value ? C - P.clientX + (_ - C) : P.clientX - S;
      l.value = Math.round(k / C * g.value);
    }
    return W(() => s(e.tag, {
      ref: m,
      class: ["v-progress-linear", {
        "v-progress-linear--active": e.active && p.value,
        "v-progress-linear--reverse": h.value,
        "v-progress-linear--rounded": e.rounded,
        "v-progress-linear--rounded-bar": e.roundedBar,
        "v-progress-linear--striped": e.striped
      }, u.value, o.value],
      style: {
        height: e.active ? z(b.value) : 0,
        "--v-progress-linear-height": z(b.value)
      },
      role: "progressbar",
      "aria-hidden": e.active ? "false" : "true",
      "aria-valuemin": "0",
      "aria-valuemax": e.max,
      "aria-valuenow": e.indeterminate ? void 0 : V.value,
      onClick: e.clickable && B
    }, {
      default: () => [e.stream && s("div", {
        key: "stream",
        class: ["v-progress-linear__stream", i.value],
        style: {
          ...r.value,
          [h.value ? "left" : "right"]: z(-b.value),
          borderTop: `${z(b.value / 2)} dotted`,
          opacity: x.value,
          top: `calc(50% - ${z(b.value / 4)})`,
          width: z(100 - w.value, "%"),
          "--v-progress-linear-stream-to": z(b.value * (h.value ? 1 : -1))
        }
      }, null), s("div", {
        class: ["v-progress-linear__background", c.value],
        style: [v.value, {
          opacity: x.value,
          width: z(e.stream ? w.value : 100, "%")
        }]
      }, null), s(Ce, {
        name: I.value
      }, {
        default: () => [e.indeterminate ? s("div", {
          class: "v-progress-linear__indeterminate"
        }, [["long", "short"].map((P) => s("div", {
          key: P,
          class: ["v-progress-linear__indeterminate", P, f.value],
          style: d.value
        }, null))]) : s("div", {
          class: ["v-progress-linear__determinate", f.value],
          style: [d.value, {
            width: z(V.value, "%")
          }]
        }, null)]
      }), n.default && s("div", {
        class: "v-progress-linear__content"
      }, [n.default({
        value: V.value,
        buffer: w.value
      })])]
    })), {};
  }
}), Aa = R({
  loading: [Boolean, String]
}, "loader");
function Oa(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ge();
  return {
    loaderClasses: y(() => ({
      [`${t}--loading`]: e.loading
    }))
  };
}
function Ea(e, t) {
  var n;
  let {
    slots: l
  } = t;
  return s("div", {
    class: `${e.name}__loader`
  }, [((n = l.default) == null ? void 0 : n.call(l, {
    color: e.color,
    isActive: e.active
  })) || s(Pa, {
    active: e.active,
    color: e.color,
    height: "2",
    indeterminate: !0
  }, null)]);
}
const rl = R({
  focused: Boolean
}, "focus");
function mt(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ge();
  const n = q(e, "focused"), l = y(() => ({
    [`${t}--focused`]: n.value
  }));
  function a() {
    n.value = !0;
  }
  function o() {
    n.value = !1;
  }
  return {
    focusClasses: l,
    isFocused: n,
    focus: a,
    blur: o
  };
}
const Ba = ["underlined", "outlined", "filled", "solo", "plain"], en = R({
  appendInnerIcon: K,
  bgColor: String,
  clearable: Boolean,
  clearIcon: {
    type: K,
    default: "$clear"
  },
  active: Boolean,
  color: String,
  dirty: Boolean,
  disabled: Boolean,
  error: Boolean,
  label: String,
  persistentClear: Boolean,
  prependInnerIcon: K,
  reverse: Boolean,
  singleLine: Boolean,
  variant: {
    type: String,
    default: "filled",
    validator: (e) => Ba.includes(e)
  },
  "onClick:clear": Se,
  "onClick:appendInner": Se,
  "onClick:prependInner": Se,
  ...ae(),
  ...Aa()
}, "v-field"), tn = ne()({
  name: "VField",
  inheritAttrs: !1,
  props: {
    id: String,
    ...rl(),
    ...en()
  },
  emits: {
    "click:control": (e) => !0,
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      emit: l,
      slots: a
    } = t;
    const {
      themeClasses: o
    } = ce(e), {
      loaderClasses: i
    } = Oa(e), {
      focusClasses: r,
      isFocused: c,
      focus: v,
      blur: f
    } = mt(e), {
      InputIcon: d
    } = il(e), u = y(() => e.dirty || e.active), m = y(() => !e.singleLine && !!(e.label || a.label)), p = ue(), g = y(() => e.id || `input-${p}`), b = A(), w = A(), V = A(), {
      backgroundColorClasses: h,
      backgroundColorStyles: I
    } = $e(j(e, "bgColor")), {
      textColorClasses: x,
      textColorStyles: B
    } = Ee(y(() => u.value && c.value && !e.error && !e.disabled ? e.color : void 0));
    H(u, (_) => {
      if (m.value) {
        const C = b.value.$el, k = w.value.$el, $ = Wt(C), O = k.getBoundingClientRect(), E = O.x - $.x, L = O.y - $.y - ($.height / 2 - O.height / 2), N = O.width / 0.75, T = Math.abs(N - $.width) > 1 ? {
          maxWidth: z(N)
        } : void 0, F = getComputedStyle(C), D = getComputedStyle(k), U = parseFloat(F.transitionDuration) * 1e3 || 150, Y = parseFloat(D.getPropertyValue("--v-field-label-scale")), he = D.getPropertyValue("color");
        C.style.visibility = "visible", k.style.visibility = "hidden", ke(C, {
          transform: `translate(${E}px, ${L}px) scale(${Y})`,
          color: he,
          ...T
        }, {
          duration: U,
          easing: ot,
          direction: _ ? "normal" : "reverse"
        }).finished.then(() => {
          C.style.removeProperty("visibility"), k.style.removeProperty("visibility");
        });
      }
    }, {
      flush: "post"
    });
    const P = y(() => ({
      isActive: u,
      isFocused: c,
      controlRef: V,
      blur: f,
      focus: v
    }));
    function S(_) {
      _.target !== document.activeElement && _.preventDefault(), l("click:control", _);
    }
    return W(() => {
      var _, C, k;
      const $ = e.variant === "outlined", O = a["prepend-inner"] || e.prependInnerIcon, E = !!(e.clearable || a.clear), L = !!(a["append-inner"] || e.appendInnerIcon || E), N = a.label ? a.label({
        label: e.label,
        props: {
          for: g.value
        }
      }) : e.label;
      return s("div", M({
        class: ["v-field", {
          "v-field--active": u.value,
          "v-field--appended": L,
          "v-field--disabled": e.disabled,
          "v-field--dirty": e.dirty,
          "v-field--error": e.error,
          "v-field--has-background": !!e.bgColor,
          "v-field--persistent-clear": e.persistentClear,
          "v-field--prepended": O,
          "v-field--reverse": e.reverse,
          "v-field--single-line": e.singleLine,
          "v-field--no-label": !N,
          [`v-field--variant-${e.variant}`]: !0
        }, o.value, h.value, r.value, i.value],
        style: [I.value, B.value],
        onClick: S
      }, n), [s("div", {
        class: "v-field__overlay"
      }, null), s(Ea, {
        name: "v-field",
        active: !!e.loading,
        color: e.error ? "error" : e.color
      }, {
        default: a.loader
      }), O && s("div", {
        key: "prepend",
        class: "v-field__prepend-inner"
      }, [e.prependInnerIcon && s(d, {
        key: "prepend-icon",
        name: "prependInner"
      }, null), (_ = a["prepend-inner"]) == null ? void 0 : _.call(a, P.value)]), s("div", {
        class: "v-field__field",
        "data-no-activator": ""
      }, [["solo", "filled"].includes(e.variant) && m.value && s(et, {
        key: "floating-label",
        ref: w,
        class: [x.value],
        floating: !0,
        for: g.value
      }, {
        default: () => [N]
      }), s(et, {
        ref: b,
        for: g.value
      }, {
        default: () => [N]
      }), (C = a.default) == null ? void 0 : C.call(a, {
        ...P.value,
        props: {
          id: g.value,
          class: "v-field__input"
        },
        focus: v,
        blur: f
      })]), E && s(al, {
        key: "clear"
      }, {
        default: () => [Q(s("div", {
          class: "v-field__clearable"
        }, [a.clear ? a.clear() : s(d, {
          name: "clear"
        }, null)]), [[Oe, e.dirty]])]
      }), L && s("div", {
        key: "append",
        class: "v-field__append-inner"
      }, [(k = a["append-inner"]) == null ? void 0 : k.call(a, P.value), e.appendInnerIcon && s(d, {
        key: "append-icon",
        name: "appendInner"
      }, null)]), s("div", {
        class: ["v-field__outline", x.value]
      }, [$ && s(Z, null, [s("div", {
        class: "v-field__outline__start"
      }, null), m.value && s("div", {
        class: "v-field__outline__notch"
      }, [s(et, {
        ref: w,
        floating: !0,
        for: g.value
      }, {
        default: () => [N]
      })]), s("div", {
        class: "v-field__outline__end"
      }, null)]), ["plain", "underlined"].includes(e.variant) && m.value && s(et, {
        ref: w,
        floating: !0,
        for: g.value
      }, {
        default: () => [N]
      })])]);
    }), {
      controlRef: V
    };
  }
});
function sl(e) {
  const t = Object.keys(tn.props).filter((n) => !Gn(n));
  return fe(e, t);
}
const Fe = R({
  transition: {
    type: [Boolean, String, Object],
    default: "fade-transition",
    validator: (e) => e !== !0
  }
}, "transition"), pe = (e, t) => {
  let {
    slots: n
  } = t;
  const {
    transition: l,
    ...a
  } = e, {
    component: o = Ce,
    ...i
  } = typeof l == "object" ? l : {};
  return Ge(o, M(typeof l == "string" ? {
    name: l
  } : i, a), n);
}, La = G({
  name: "VMessages",
  props: {
    active: Boolean,
    color: String,
    messages: {
      type: [Array, String],
      default: () => []
    },
    ...Fe({
      transition: {
        component: ll,
        leaveAbsolute: !0,
        group: !0
      }
    })
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const l = y(() => ve(e.messages)), {
      textColorClasses: a,
      textColorStyles: o
    } = Ee(y(() => e.color));
    return W(() => s(pe, {
      transition: e.transition,
      tag: "div",
      class: ["v-messages", a.value],
      style: o.value
    }, {
      default: () => [e.active && l.value.map((i, r) => s("div", {
        class: "v-messages__message",
        key: `${r}-${l.value}`
      }, [n.message ? n.message({
        message: i
      }) : i]))]
    })), {};
  }
}), Fa = [null, "default", "comfortable", "compact"], Te = R({
  density: {
    type: String,
    default: "default",
    validator: (e) => Fa.includes(e)
  }
}, "density");
function De(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ge();
  return {
    densityClasses: y(() => `${t}--density-${e.density}`)
  };
}
const Ta = Symbol.for("vuetify:form");
function Da() {
  return X(Ta, null);
}
const Ra = R({
  disabled: Boolean,
  error: Boolean,
  errorMessages: {
    type: [Array, String],
    default: () => []
  },
  maxErrors: {
    type: [Number, String],
    default: 1
  },
  name: String,
  label: String,
  readonly: Boolean,
  rules: {
    type: Array,
    default: () => []
  },
  modelValue: null,
  validateOn: String,
  validationValue: null,
  ...rl()
}, "validation");
function Na(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ge(), n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ue();
  const l = q(e, "modelValue"), a = y(() => e.validationValue === void 0 ? l.value : e.validationValue), o = Da(), i = A([]), r = A(!0), c = y(() => !!(ve(l.value === "" ? null : l.value).length || ve(a.value === "" ? null : a.value).length)), v = y(() => !!(e.disabled || o != null && o.isDisabled.value)), f = y(() => !!(e.readonly || o != null && o.isReadonly.value)), d = y(() => e.errorMessages.length ? ve(e.errorMessages).slice(0, Math.max(0, +e.maxErrors)) : i.value), u = y(() => e.error || d.value.length ? !1 : e.rules.length && r.value ? null : !0), m = A(!1), p = y(() => ({
    [`${t}--error`]: u.value === !1,
    [`${t}--dirty`]: c.value,
    [`${t}--disabled`]: v.value,
    [`${t}--readonly`]: f.value
  })), g = y(() => e.name ?? be(n));
  zn(() => {
    o == null || o.register({
      id: g.value,
      validate: h,
      reset: w,
      resetValidation: V
    });
  }), _e(() => {
    o == null || o.unregister(g.value);
  });
  const b = y(() => e.validateOn || (o == null ? void 0 : o.validateOn.value) || "input");
  Ue(() => o == null ? void 0 : o.update(g.value, u.value, d.value)), Ve(() => b.value === "input", () => {
    H(a, () => {
      if (a.value != null)
        h();
      else if (e.focused) {
        const I = H(() => e.focused, (x) => {
          x || h(), I();
        });
      }
    });
  }), Ve(() => b.value === "blur", () => {
    H(() => e.focused, (I) => {
      I || h();
    });
  }), H(u, () => {
    o == null || o.update(g.value, u.value, d.value);
  });
  function w() {
    V(), l.value = null;
  }
  function V() {
    r.value = !0, i.value = [];
  }
  async function h() {
    const I = [];
    m.value = !0;
    for (const x of e.rules) {
      if (I.length >= (e.maxErrors ?? 1))
        break;
      const P = await (typeof x == "function" ? x : () => x)(a.value);
      if (P !== !0) {
        if (typeof P != "string") {
          console.warn(`${P} is not a valid value. Rule functions must return boolean true or a string.`);
          continue;
        }
        I.push(P);
      }
    }
    return i.value = I, m.value = !1, r.value = !1, i.value;
  }
  return {
    errorMessages: d,
    isDirty: c,
    isDisabled: v,
    isReadonly: f,
    isPristine: r,
    isValid: u,
    isValidating: m,
    reset: w,
    resetValidation: V,
    validate: h,
    validationClasses: p
  };
}
const Ze = R({
  id: String,
  appendIcon: K,
  prependIcon: K,
  hideDetails: [Boolean, String],
  messages: {
    type: [Array, String],
    default: () => []
  },
  direction: {
    type: String,
    default: "horizontal",
    validator: (e) => ["horizontal", "vertical"].includes(e)
  },
  "onClick:prepend": Se,
  "onClick:append": Se,
  ...Te(),
  ...Ra()
}, "v-input"), Je = ne()({
  name: "VInput",
  props: {
    ...Ze()
  },
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: l,
      emit: a
    } = t;
    const {
      densityClasses: o
    } = De(e), {
      InputIcon: i
    } = il(e), r = ue(), c = y(() => e.id || `input-${r}`), {
      errorMessages: v,
      isDirty: f,
      isDisabled: d,
      isReadonly: u,
      isPristine: m,
      isValid: p,
      isValidating: g,
      reset: b,
      resetValidation: w,
      validate: V,
      validationClasses: h
    } = Na(e, "v-input", c), I = y(() => ({
      id: c,
      isDirty: f,
      isDisabled: d,
      isReadonly: u,
      isPristine: m,
      isValid: p,
      isValidating: g,
      reset: b,
      resetValidation: w,
      validate: V
    }));
    return W(() => {
      var x, B, P, S, _;
      const C = !!(l.prepend || e.prependIcon), k = !!(l.append || e.appendIcon), $ = !!((x = e.messages) != null && x.length || v.value.length), O = !e.hideDetails || e.hideDetails === "auto" && ($ || !!l.details);
      return s("div", {
        class: ["v-input", `v-input--${e.direction}`, o.value, h.value]
      }, [C && s("div", {
        key: "prepend",
        class: "v-input__prepend"
      }, [(B = l.prepend) == null ? void 0 : B.call(l, I.value), e.prependIcon && s(i, {
        key: "prepend-icon",
        name: "prepend"
      }, null)]), l.default && s("div", {
        class: "v-input__control"
      }, [(P = l.default) == null ? void 0 : P.call(l, I.value)]), k && s("div", {
        key: "append",
        class: "v-input__append"
      }, [e.appendIcon && s(i, {
        key: "append-icon",
        name: "append"
      }, null), (S = l.append) == null ? void 0 : S.call(l, I.value)]), O && s("div", {
        class: "v-input__details"
      }, [s(La, {
        active: $,
        messages: v.value.length > 0 ? v.value : e.messages
      }, {
        message: l.message
      }), (_ = l.details) == null ? void 0 : _.call(l, I.value)])]);
    }), {
      reset: b,
      resetValidation: w,
      validate: V
    };
  }
});
function gt(e) {
  const t = Object.keys(Je.props).filter((n) => !Gn(n));
  return fe(e, t);
}
const ul = G({
  name: "VCounter",
  functional: !0,
  props: {
    active: Boolean,
    max: [Number, String],
    value: {
      type: [Number, String],
      default: 0
    },
    ...Fe({
      transition: {
        component: ll
      }
    })
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const l = y(() => e.max ? `${e.value} / ${e.max}` : String(e.value));
    return W(() => s(pe, {
      transition: e.transition
    }, {
      default: () => [Q(s("div", {
        class: "v-counter"
      }, [n.default ? n.default({
        counter: l.value,
        max: e.max,
        value: e.value
      }) : l.value]), [[Oe, e.active]])]
    })), {};
  }
});
function Ma(e, t) {
  if (!Kt)
    return;
  const n = t.modifiers || {}, l = t.value, {
    handler: a,
    options: o
  } = typeof l == "object" ? l : {
    handler: l,
    options: {}
  }, i = new IntersectionObserver(function() {
    var r;
    let c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], v = arguments.length > 1 ? arguments[1] : void 0;
    const f = (r = e._observe) == null ? void 0 : r[t.instance.$.uid];
    if (!f)
      return;
    const d = c.some((u) => u.isIntersecting);
    a && (!n.quiet || f.init) && (!n.once || d || f.init) && a(d, c, v), d && n.once ? cl(e, t) : f.init = !0;
  }, o);
  e._observe = Object(e._observe), e._observe[t.instance.$.uid] = {
    init: !1,
    observer: i
  }, i.observe(e);
}
function cl(e, t) {
  var n;
  const l = (n = e._observe) == null ? void 0 : n[t.instance.$.uid];
  l && (l.observer.unobserve(e), delete e._observe[t.instance.$.uid]);
}
const za = {
  mounted: Ma,
  unmounted: cl
}, nn = za, It = Symbol("Forwarded refs");
function Re(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), l = 1; l < t; l++)
    n[l - 1] = arguments[l];
  return e[It] = n, new Proxy(e, {
    get(a, o) {
      if (Reflect.has(a, o))
        return Reflect.get(a, o);
      for (const i of n)
        if (i.value && Reflect.has(i.value, o)) {
          const r = Reflect.get(i.value, o);
          return typeof r == "function" ? r.bind(i.value) : r;
        }
    },
    getOwnPropertyDescriptor(a, o) {
      const i = Reflect.getOwnPropertyDescriptor(a, o);
      if (i)
        return i;
      if (!(typeof o == "symbol" || o.startsWith("__"))) {
        for (const r of n) {
          if (!r.value)
            continue;
          const c = Reflect.getOwnPropertyDescriptor(r.value, o);
          if (c)
            return c;
          if ("_" in r.value && "setupState" in r.value._) {
            const v = Reflect.getOwnPropertyDescriptor(r.value._.setupState, o);
            if (v)
              return v;
          }
        }
        for (const r of n) {
          let c = r.value && Object.getPrototypeOf(r.value);
          for (; c; ) {
            const v = Reflect.getOwnPropertyDescriptor(c, o);
            if (v)
              return v;
            c = Object.getPrototypeOf(c);
          }
        }
        for (const r of n) {
          const c = r.value && r.value[It];
          if (!c)
            continue;
          const v = c.slice();
          for (; v.length; ) {
            const f = v.shift(), d = Reflect.getOwnPropertyDescriptor(f.value, o);
            if (d)
              return d;
            const u = f.value && f.value[It];
            u && v.push(...u);
          }
        }
      }
    }
  });
}
const Ha = ["color", "file", "time", "date", "datetime-local", "week", "month"], ln = R({
  autofocus: Boolean,
  counter: [Boolean, Number, String],
  counterValue: Function,
  hint: String,
  persistentHint: Boolean,
  prefix: String,
  placeholder: String,
  persistentPlaceholder: Boolean,
  persistentCounter: Boolean,
  suffix: String,
  type: {
    type: String,
    default: "text"
  },
  ...Ze(),
  ...en()
}, "v-text-field"), yt = ne()({
  name: "VTextField",
  directives: {
    Intersect: nn
  },
  inheritAttrs: !1,
  props: ln(),
  emits: {
    "click:control": (e) => !0,
    "click:input": (e) => !0,
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      emit: l,
      slots: a
    } = t;
    const o = q(e, "modelValue"), {
      isFocused: i,
      focus: r,
      blur: c
    } = mt(e), v = y(() => typeof e.counterValue == "function" ? e.counterValue(o.value) : (o.value ?? "").toString().length), f = y(() => {
      if (n.maxlength)
        return n.maxlength;
      if (!(!e.counter || typeof e.counter != "number" && typeof e.counter != "string"))
        return e.counter;
    });
    function d(x, B) {
      var P, S;
      !e.autofocus || !x || (P = B[0].target) == null || (S = P.focus) == null || S.call(P);
    }
    const u = A(), m = A(), p = A(), g = y(() => Ha.includes(e.type) || e.persistentPlaceholder || i.value), b = y(() => e.messages.length ? e.messages : i.value || e.persistentHint ? e.hint : "");
    function w() {
      if (p.value !== document.activeElement) {
        var x;
        (x = p.value) == null || x.focus();
      }
      i.value || r();
    }
    function V(x) {
      w(), l("click:control", x);
    }
    function h(x) {
      x.stopPropagation(), w(), ee(() => {
        o.value = null, Un(e["onClick:clear"], x);
      });
    }
    function I(x) {
      o.value = x.target.value;
    }
    return W(() => {
      const x = !!(a.counter || e.counter || e.counterValue), B = !!(x || a.details), [P, S] = Ye(n), [{
        modelValue: _,
        ...C
      }] = gt(e), [k] = sl(e);
      return s(Je, M({
        ref: u,
        modelValue: o.value,
        "onUpdate:modelValue": ($) => o.value = $,
        class: ["v-text-field", {
          "v-text-field--prefixed": e.prefix,
          "v-text-field--suffixed": e.suffix,
          "v-text-field--flush-details": ["plain", "underlined"].includes(e.variant)
        }],
        "onClick:prepend": e["onClick:prepend"],
        "onClick:append": e["onClick:append"]
      }, P, C, {
        focused: i.value,
        messages: b.value
      }), {
        ...a,
        default: ($) => {
          let {
            id: O,
            isDisabled: E,
            isDirty: L,
            isReadonly: N,
            isValid: T
          } = $;
          return s(tn, M({
            ref: m,
            onMousedown: (F) => {
              F.target !== p.value && F.preventDefault();
            },
            "onClick:control": V,
            "onClick:clear": h,
            "onClick:prependInner": e["onClick:prependInner"],
            "onClick:appendInner": e["onClick:appendInner"],
            role: "textbox"
          }, k, {
            id: O.value,
            active: g.value || L.value,
            dirty: L.value || e.dirty,
            focused: i.value,
            error: T.value === !1
          }), {
            ...a,
            default: (F) => {
              let {
                props: {
                  class: D,
                  ...U
                }
              } = F;
              const Y = Q(s("input", M({
                ref: p,
                value: o.value,
                onInput: I,
                autofocus: e.autofocus,
                readonly: N.value,
                disabled: E.value,
                name: e.name,
                placeholder: e.placeholder,
                size: 1,
                type: e.type,
                onFocus: w,
                onBlur: c
              }, U, S), null), [[we("intersect"), {
                handler: d
              }, null, {
                once: !0
              }]]);
              return s(Z, null, [e.prefix && s("span", {
                class: "v-text-field__prefix"
              }, [e.prefix]), a.default ? s("div", {
                class: D,
                onClick: (he) => l("click:input", he),
                "data-no-activator": ""
              }, [a.default(), Y]) : ta(Y, {
                class: D
              }), e.suffix && s("span", {
                class: "v-text-field__suffix"
              }, [e.suffix])]);
            }
          });
        },
        details: B ? ($) => {
          var O;
          return s(Z, null, [(O = a.details) == null ? void 0 : O.call(a, $), x && s(Z, null, [s("span", null, null), s(ul, {
            active: e.persistentCounter || i.value,
            value: v.value,
            max: f.value
          }, a.counter)])]);
        } : void 0
      });
    }), Re({}, u, m, p);
  }
});
function dl(e) {
  return fe(e, Object.keys(yt.props));
}
const vl = Symbol.for("vuetify:selection-control-group"), an = R({
  color: String,
  disabled: Boolean,
  error: Boolean,
  id: String,
  inline: Boolean,
  falseIcon: K,
  trueIcon: K,
  ripple: {
    type: Boolean,
    default: !0
  },
  multiple: {
    type: Boolean,
    default: null
  },
  name: String,
  readonly: Boolean,
  modelValue: null,
  type: String,
  valueComparator: {
    type: Function,
    default: Ke
  },
  ...ae(),
  ...Te()
}, "v-selection-control-group"), ja = G({
  name: "VSelectionControlGroup",
  props: {
    defaultsTarget: {
      type: String,
      default: "VSelectionControl"
    },
    ...an()
  },
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const l = q(e, "modelValue"), a = ue(), o = y(() => e.id || `v-selection-control-group-${a}`), i = y(() => e.name || o.value), r = /* @__PURE__ */ new Set();
    return re(vl, {
      modelValue: l,
      forceUpdate: () => {
        r.forEach((c) => c());
      },
      onForceUpdate: (c) => {
        r.add(c), se(() => {
          r.delete(c);
        });
      }
    }), Xe({
      [e.defaultsTarget]: {
        color: j(e, "color"),
        disabled: j(e, "disabled"),
        density: j(e, "density"),
        error: j(e, "error"),
        inline: j(e, "inline"),
        modelValue: l,
        multiple: y(() => !!e.multiple || e.multiple == null && Array.isArray(l.value)),
        name: i,
        falseIcon: j(e, "falseIcon"),
        trueIcon: j(e, "trueIcon"),
        readonly: j(e, "readonly"),
        ripple: j(e, "ripple"),
        type: j(e, "type"),
        valueComparator: j(e, "valueComparator")
      }
    }), W(() => {
      var c;
      return s("div", {
        class: ["v-selection-control-group", {
          "v-selection-control-group--inline": e.inline
        }],
        role: e.type === "radio" ? "radiogroup" : void 0
      }, [(c = n.default) == null ? void 0 : c.call(n)]);
    }), {};
  }
});
const Tt = Symbol("rippleStop"), Wa = 80;
function $n(e, t) {
  e.style.transform = t, e.style.webkitTransform = t;
}
function Pt(e, t) {
  e.style.opacity = `calc(${t} * var(--v-theme-overlay-multiplier))`;
}
function Dt(e) {
  return e.constructor.name === "TouchEvent";
}
function fl(e) {
  return e.constructor.name === "KeyboardEvent";
}
const Ga = function(e, t) {
  var n;
  let l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = 0, o = 0;
  if (!fl(e)) {
    const u = t.getBoundingClientRect(), m = Dt(e) ? e.touches[e.touches.length - 1] : e;
    a = m.clientX - u.left, o = m.clientY - u.top;
  }
  let i = 0, r = 0.3;
  (n = t._ripple) != null && n.circle ? (r = 0.15, i = t.clientWidth / 2, i = l.center ? i : i + Math.sqrt((a - i) ** 2 + (o - i) ** 2) / 4) : i = Math.sqrt(t.clientWidth ** 2 + t.clientHeight ** 2) / 2;
  const c = `${(t.clientWidth - i * 2) / 2}px`, v = `${(t.clientHeight - i * 2) / 2}px`, f = l.center ? c : `${a - i}px`, d = l.center ? v : `${o - i}px`;
  return {
    radius: i,
    scale: r,
    x: f,
    y: d,
    centerX: c,
    centerY: v
  };
}, rt = {
  /* eslint-disable max-statements */
  show(e, t) {
    var n;
    let l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!(t != null && (n = t._ripple) != null && n.enabled))
      return;
    const a = document.createElement("span"), o = document.createElement("span");
    a.appendChild(o), a.className = "v-ripple__container", l.class && (a.className += ` ${l.class}`);
    const {
      radius: i,
      scale: r,
      x: c,
      y: v,
      centerX: f,
      centerY: d
    } = Ga(e, t, l), u = `${i * 2}px`;
    o.className = "v-ripple__animation", o.style.width = u, o.style.height = u, t.appendChild(a);
    const m = window.getComputedStyle(t);
    m && m.position === "static" && (t.style.position = "relative", t.dataset.previousPosition = "static"), o.classList.add("v-ripple__animation--enter"), o.classList.add("v-ripple__animation--visible"), $n(o, `translate(${c}, ${v}) scale3d(${r},${r},${r})`), Pt(o, 0), o.dataset.activated = String(performance.now()), setTimeout(() => {
      o.classList.remove("v-ripple__animation--enter"), o.classList.add("v-ripple__animation--in"), $n(o, `translate(${f}, ${d}) scale3d(1,1,1)`), Pt(o, 0.08);
    }, 0);
  },
  hide(e) {
    var t;
    if (!(e != null && (t = e._ripple) != null && t.enabled))
      return;
    const n = e.getElementsByClassName("v-ripple__animation");
    if (n.length === 0)
      return;
    const l = n[n.length - 1];
    if (l.dataset.isHiding)
      return;
    l.dataset.isHiding = "true";
    const a = performance.now() - Number(l.dataset.activated), o = Math.max(250 - a, 0);
    setTimeout(() => {
      l.classList.remove("v-ripple__animation--in"), l.classList.add("v-ripple__animation--out"), Pt(l, 0), setTimeout(() => {
        e.getElementsByClassName("v-ripple__animation").length === 1 && e.dataset.previousPosition && (e.style.position = e.dataset.previousPosition, delete e.dataset.previousPosition), l.parentNode && e.removeChild(l.parentNode);
      }, 300);
    }, o);
  }
};
function ml(e) {
  return typeof e > "u" || !!e;
}
function He(e) {
  const t = {}, n = e.currentTarget;
  if (!(!(n != null && n._ripple) || n._ripple.touched || e[Tt])) {
    if (e[Tt] = !0, Dt(e))
      n._ripple.touched = !0, n._ripple.isTouch = !0;
    else if (n._ripple.isTouch)
      return;
    if (t.center = n._ripple.centered || fl(e), n._ripple.class && (t.class = n._ripple.class), Dt(e)) {
      if (n._ripple.showTimerCommit)
        return;
      n._ripple.showTimerCommit = () => {
        rt.show(e, n, t);
      }, n._ripple.showTimer = window.setTimeout(() => {
        var l;
        n != null && (l = n._ripple) != null && l.showTimerCommit && (n._ripple.showTimerCommit(), n._ripple.showTimerCommit = null);
      }, Wa);
    } else
      rt.show(e, n, t);
  }
}
function In(e) {
  e[Tt] = !0;
}
function J(e) {
  const t = e.currentTarget;
  if (!(!t || !t._ripple)) {
    if (window.clearTimeout(t._ripple.showTimer), e.type === "touchend" && t._ripple.showTimerCommit) {
      t._ripple.showTimerCommit(), t._ripple.showTimerCommit = null, t._ripple.showTimer = window.setTimeout(() => {
        J(e);
      });
      return;
    }
    window.setTimeout(() => {
      t._ripple && (t._ripple.touched = !1);
    }), rt.hide(t);
  }
}
function gl(e) {
  const t = e.currentTarget;
  !t || !t._ripple || (t._ripple.showTimerCommit && (t._ripple.showTimerCommit = null), window.clearTimeout(t._ripple.showTimer));
}
let je = !1;
function yl(e) {
  !je && (e.keyCode === hn.enter || e.keyCode === hn.space) && (je = !0, He(e));
}
function hl(e) {
  je = !1, J(e);
}
function pl(e) {
  je && (je = !1, J(e));
}
function bl(e, t, n) {
  const {
    value: l,
    modifiers: a
  } = t, o = ml(l);
  if (o || rt.hide(e), e._ripple = e._ripple ?? {}, e._ripple.enabled = o, e._ripple.centered = a.center, e._ripple.circle = a.circle, Et(l) && l.class && (e._ripple.class = l.class), o && !n) {
    if (a.stop) {
      e.addEventListener("touchstart", In, {
        passive: !0
      }), e.addEventListener("mousedown", In);
      return;
    }
    e.addEventListener("touchstart", He, {
      passive: !0
    }), e.addEventListener("touchend", J, {
      passive: !0
    }), e.addEventListener("touchmove", gl, {
      passive: !0
    }), e.addEventListener("touchcancel", J), e.addEventListener("mousedown", He), e.addEventListener("mouseup", J), e.addEventListener("mouseleave", J), e.addEventListener("keydown", yl), e.addEventListener("keyup", hl), e.addEventListener("blur", pl), e.addEventListener("dragstart", J, {
      passive: !0
    });
  } else
    !o && n && Sl(e);
}
function Sl(e) {
  e.removeEventListener("mousedown", He), e.removeEventListener("touchstart", He), e.removeEventListener("touchend", J), e.removeEventListener("touchmove", gl), e.removeEventListener("touchcancel", J), e.removeEventListener("mouseup", J), e.removeEventListener("mouseleave", J), e.removeEventListener("keydown", yl), e.removeEventListener("keyup", hl), e.removeEventListener("dragstart", J), e.removeEventListener("blur", pl);
}
function Ua(e, t) {
  bl(e, t, !1);
}
function Ka(e) {
  delete e._ripple, Sl(e);
}
function qa(e, t) {
  if (t.value === t.oldValue)
    return;
  const n = ml(t.oldValue);
  bl(e, t, n);
}
const on = {
  mounted: Ua,
  unmounted: Ka,
  updated: qa
}, rn = R({
  label: String,
  trueValue: null,
  falseValue: null,
  value: null,
  ...an()
}, "v-selection-control");
function Ya(e) {
  const t = X(vl, void 0), {
    densityClasses: n
  } = De(e), l = q(e, "modelValue"), a = y(() => e.trueValue !== void 0 ? e.trueValue : e.value !== void 0 ? e.value : !0), o = y(() => e.falseValue !== void 0 ? e.falseValue : !1), i = y(() => !!e.multiple || e.multiple == null && Array.isArray(l.value)), r = y({
    get() {
      const d = t ? t.modelValue.value : l.value;
      return i.value ? d.some((u) => e.valueComparator(u, a.value)) : e.valueComparator(d, a.value);
    },
    set(d) {
      if (e.readonly)
        return;
      const u = d ? a.value : o.value;
      let m = u;
      i.value && (m = d ? [...ve(l.value), u] : ve(l.value).filter((p) => !e.valueComparator(p, a.value))), t ? t.modelValue.value = m : l.value = m;
    }
  }), {
    textColorClasses: c,
    textColorStyles: v
  } = Ee(y(() => r.value && !e.error && !e.disabled ? e.color : void 0)), f = y(() => r.value ? e.trueIcon : e.falseIcon);
  return {
    group: t,
    densityClasses: n,
    trueValue: a,
    falseValue: o,
    model: r,
    textColorClasses: c,
    textColorStyles: v,
    icon: f
  };
}
const sn = ne()({
  name: "VSelectionControl",
  directives: {
    Ripple: on
  },
  inheritAttrs: !1,
  props: rn(),
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: l
    } = t;
    const {
      group: a,
      densityClasses: o,
      icon: i,
      model: r,
      textColorClasses: c,
      textColorStyles: v,
      trueValue: f
    } = Ya(e), d = ue(), u = y(() => e.id || `input-${d}`), m = A(!1), p = A(!1), g = A();
    a == null || a.onForceUpdate(() => {
      g.value && (g.value.checked = r.value);
    });
    function b(h) {
      m.value = !0, (!Ft || Ft && h.target.matches(":focus-visible")) && (p.value = !0);
    }
    function w() {
      m.value = !1, p.value = !1;
    }
    function V(h) {
      e.readonly && a && ee(() => a.forceUpdate()), r.value = h.target.checked;
    }
    return W(() => {
      var h, I;
      const x = l.label ? l.label({
        label: e.label,
        props: {
          for: u.value
        }
      }) : e.label, [B, P] = Ye(n);
      return s("div", M({
        class: ["v-selection-control", {
          "v-selection-control--dirty": r.value,
          "v-selection-control--disabled": e.disabled,
          "v-selection-control--error": e.error,
          "v-selection-control--focused": m.value,
          "v-selection-control--focus-visible": p.value,
          "v-selection-control--inline": e.inline
        }, o.value]
      }, B), [s("div", {
        class: ["v-selection-control__wrapper", c.value],
        style: v.value
      }, [(h = l.default) == null ? void 0 : h.call(l), Q(s("div", {
        class: ["v-selection-control__input"]
      }, [i.value && s(me, {
        key: "icon",
        icon: i.value
      }, null), s("input", M({
        ref: g,
        checked: r.value,
        disabled: e.disabled,
        id: u.value,
        onBlur: w,
        onFocus: b,
        onInput: V,
        "aria-disabled": e.readonly,
        type: e.type,
        value: f.value,
        name: e.name,
        "aria-checked": e.type === "checkbox" ? r.value : void 0
      }, P), null), (I = l.input) == null ? void 0 : I.call(l, {
        model: r,
        textColorClasses: c,
        textColorStyles: v,
        props: {
          onFocus: b,
          onBlur: w,
          id: u.value
        }
      })]), [[we("ripple"), e.ripple && [!e.disabled && !e.readonly, null, ["center", "circle"]]]])]), x && s(Qt, {
        for: u.value,
        clickable: !0
      }, {
        default: () => [x]
      })]);
    }), {
      isFocused: m,
      input: g
    };
  }
});
function Xa(e) {
  return fe(e, Object.keys(sn.props));
}
const Cl = R({
  indeterminate: Boolean,
  indeterminateIcon: {
    type: K,
    default: "$checkboxIndeterminate"
  },
  ...rn({
    falseIcon: "$checkboxOff",
    trueIcon: "$checkboxOn"
  })
}, "v-checkbox-btn"), ht = G({
  name: "VCheckboxBtn",
  props: Cl(),
  emits: {
    "update:modelValue": (e) => !0,
    "update:indeterminate": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const l = q(e, "indeterminate"), a = q(e, "modelValue");
    function o(c) {
      l.value && (l.value = !1);
    }
    const i = y(() => e.indeterminate ? e.indeterminateIcon : e.falseIcon), r = y(() => e.indeterminate ? e.indeterminateIcon : e.trueIcon);
    return W(() => s(sn, M(e, {
      modelValue: a.value,
      "onUpdate:modelValue": [(c) => a.value = c, o],
      class: "v-checkbox-btn",
      type: "checkbox",
      inline: !0,
      falseIcon: i.value,
      trueIcon: r.value,
      "aria-checked": e.indeterminate ? "mixed" : void 0
    }), n)), {};
  }
});
function Za(e) {
  return fe(e, Object.keys(ht.props));
}
const Ja = G({
  name: "VCheckbox",
  inheritAttrs: !1,
  props: {
    ...Ze(),
    ...Cl()
  },
  emits: {
    "update:focused": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: l
    } = t;
    const {
      isFocused: a,
      focus: o,
      blur: i
    } = mt(e), r = ue(), c = y(() => e.id || `checkbox-${r}`);
    return W(() => {
      const [v, f] = Ye(n), [d, u] = gt(e), [m, p] = Za(e);
      return s(Je, M({
        class: "v-checkbox"
      }, v, d, {
        id: c.value,
        focused: a.value
      }), {
        ...l,
        default: (g) => {
          let {
            id: b,
            isDisabled: w,
            isReadonly: V
          } = g;
          return s(ht, M(m, {
            id: b.value,
            disabled: w.value,
            readonly: V.value
          }, f, {
            onFocus: o,
            onBlur: i
          }), l);
        }
      });
    }), {};
  }
});
const ie = Nn({
  name: "VDefaultsProvider",
  props: {
    defaults: Object,
    reset: [Number, String],
    root: Boolean,
    scoped: Boolean
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      defaults: l,
      reset: a,
      root: o,
      scoped: i
    } = Tn(e);
    return Xe(l, {
      reset: a,
      root: o,
      scoped: i
    }), () => {
      var r;
      return (r = n.default) == null ? void 0 : r.call(n);
    };
  }
});
const Qa = R({
  closeDelay: [Number, String],
  openDelay: [Number, String]
}, "delay");
function eo(e, t) {
  const n = {}, l = (a) => () => {
    if (!oe)
      return Promise.resolve(!0);
    const o = a === "openDelay";
    return n.closeDelay && window.clearTimeout(n.closeDelay), delete n.closeDelay, n.openDelay && window.clearTimeout(n.openDelay), delete n.openDelay, new Promise((i) => {
      const r = parseInt(e[a] ?? 0, 10);
      n[a] = window.setTimeout(() => {
        t == null || t(o), i(o);
      }, r);
    });
  };
  return {
    runCloseDelay: l("closeDelay"),
    runOpenDelay: l("openDelay")
  };
}
const Rt = Symbol.for("vuetify:v-menu"), to = R({
  activator: [String, Object],
  activatorProps: {
    type: Object,
    default: () => ({})
  },
  openOnClick: {
    type: Boolean,
    default: void 0
  },
  openOnHover: Boolean,
  openOnFocus: {
    type: Boolean,
    default: void 0
  },
  closeOnContentClick: Boolean,
  ...Qa()
}, "v-overlay-activator");
function no(e, t) {
  let {
    isActive: n,
    isTop: l
  } = t;
  const a = A();
  let o = !1, i = !1, r = !0;
  const c = y(() => e.openOnFocus || e.openOnFocus == null && e.openOnHover), v = y(() => e.openOnClick || e.openOnClick == null && !e.openOnHover && !c.value), {
    runOpenDelay: f,
    runCloseDelay: d
  } = eo(e, (h) => {
    h === (e.openOnHover && o || c.value && i) && !(e.openOnHover && n.value && !l.value) && (n.value !== h && (r = !0), n.value = h);
  }), u = {
    click: (h) => {
      h.stopPropagation(), a.value = h.currentTarget || h.target, n.value = !n.value;
    },
    mouseenter: (h) => {
      o = !0, a.value = h.currentTarget || h.target, f();
    },
    mouseleave: (h) => {
      o = !1, d();
    },
    focus: (h) => {
      Ft && !h.target.matches(":focus-visible") || (i = !0, h.stopPropagation(), a.value = h.currentTarget || h.target, f());
    },
    blur: (h) => {
      i = !1, h.stopPropagation(), d();
    }
  }, m = y(() => {
    const h = {};
    return v.value && (h.click = u.click), e.openOnHover && (h.mouseenter = u.mouseenter, h.mouseleave = u.mouseleave), c.value && (h.focus = u.focus, h.blur = u.blur), h;
  }), p = y(() => {
    const h = {};
    if (e.openOnHover && (h.mouseenter = () => {
      o = !0, f();
    }, h.mouseleave = () => {
      o = !1, d();
    }), e.closeOnContentClick) {
      const I = X(Rt, null);
      h.click = () => {
        n.value = !1, I == null || I.closeParents();
      };
    }
    return h;
  }), g = y(() => {
    const h = {};
    return e.openOnHover && (h.mouseenter = () => {
      r && (o = !0, r = !1, f());
    }, h.mouseleave = () => {
      o = !1, d();
    }), h;
  });
  H(l, (h) => {
    h && (e.openOnHover && !o && (!c.value || !i) || c.value && !i && (!e.openOnHover || !o)) && (n.value = !1);
  });
  const b = A();
  Pe(() => {
    b.value && ee(() => {
      const h = b.value;
      a.value = sa(h) ? h.$el : h;
    });
  });
  const w = te("useActivator");
  let V;
  return H(() => !!e.activator, (h) => {
    h && oe ? (V = dt(), V.run(() => {
      lo(e, w, {
        activatorEl: a,
        activatorEvents: m
      });
    })) : V && V.stop();
  }, {
    flush: "post",
    immediate: !0
  }), se(() => {
    var h;
    (h = V) == null || h.stop();
  }), {
    activatorEl: a,
    activatorRef: b,
    activatorEvents: m,
    contentEvents: p,
    scrimEvents: g
  };
}
function lo(e, t, n) {
  let {
    activatorEl: l,
    activatorEvents: a
  } = n;
  H(() => e.activator, (c, v) => {
    if (v && c !== v) {
      const f = r(v);
      f && i(f);
    }
    c && ee(() => o());
  }, {
    immediate: !0
  }), H(() => e.activatorProps, () => {
    o();
  }), se(() => {
    i();
  });
  function o() {
    let c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : r(), v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e.activatorProps;
    c && (Object.entries(a.value).forEach((f) => {
      let [d, u] = f;
      c.addEventListener(d, u);
    }), Object.keys(v).forEach((f) => {
      v[f] == null ? c.removeAttribute(f) : c.setAttribute(f, v[f]);
    }));
  }
  function i() {
    let c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : r(), v = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e.activatorProps;
    c && (Object.entries(a.value).forEach((f) => {
      let [d, u] = f;
      c.removeEventListener(d, u);
    }), Object.keys(v).forEach((f) => {
      c.removeAttribute(f);
    }));
  }
  function r() {
    var c;
    let v = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e.activator, f;
    if (v)
      if (v === "parent") {
        var d, u;
        let m = t == null || (d = t.proxy) == null || (u = d.$el) == null ? void 0 : u.parentNode;
        for (; m.hasAttribute("data-no-activator"); )
          m = m.parentNode;
        f = m;
      } else
        typeof v == "string" ? f = document.querySelector(v) : "$el" in v ? f = v.$el : f = v;
    return l.value = ((c = f) == null ? void 0 : c.nodeType) === Node.ELEMENT_NODE ? f : null, l.value;
  }
}
const pt = R({
  height: [Number, String],
  maxHeight: [Number, String],
  maxWidth: [Number, String],
  minHeight: [Number, String],
  minWidth: [Number, String],
  width: [Number, String]
}, "dimension");
function bt(e) {
  return {
    dimensionStyles: y(() => ({
      height: z(e.height),
      maxHeight: z(e.maxHeight),
      maxWidth: z(e.maxWidth),
      minHeight: z(e.minHeight),
      minWidth: z(e.minWidth),
      width: z(e.width)
    }))
  };
}
const ao = R({
  eager: Boolean
}, "lazy");
function oo(e, t) {
  const n = A(!1), l = y(() => n.value || e.eager || t.value);
  H(t, () => n.value = !0);
  function a() {
    e.eager || (n.value = !1);
  }
  return {
    isBooted: n,
    hasContent: l,
    onAfterLeave: a
  };
}
function At(e, t) {
  return {
    x: e.x + t.x,
    y: e.y + t.y
  };
}
function io(e, t) {
  return {
    x: e.x - t.x,
    y: e.y - t.y
  };
}
function Pn(e, t) {
  if (e.side === "top" || e.side === "bottom") {
    const {
      side: n,
      align: l
    } = e, a = l === "left" ? 0 : l === "center" ? t.width / 2 : l === "right" ? t.width : l, o = n === "top" ? 0 : n === "bottom" ? t.height : n;
    return At({
      x: a,
      y: o
    }, t);
  } else if (e.side === "left" || e.side === "right") {
    const {
      side: n,
      align: l
    } = e, a = n === "left" ? 0 : n === "right" ? t.width : n, o = l === "top" ? 0 : l === "center" ? t.height / 2 : l === "bottom" ? t.height : l;
    return At({
      x: a,
      y: o
    }, t);
  }
  return At({
    x: t.width / 2,
    y: t.height / 2
  }, t);
}
const _l = {
  static: uo,
  // specific viewport position, usually centered
  connected: vo
  // connected to a certain element
}, ro = R({
  locationStrategy: {
    type: [String, Function],
    default: "static",
    validator: (e) => typeof e == "function" || e in _l
  },
  location: {
    type: String,
    default: "bottom"
  },
  origin: {
    type: String,
    default: "auto"
  },
  offset: [Number, String, Array]
}, "v-overlay-location-strategies");
function so(e, t) {
  const n = A({}), l = A();
  let a;
  Pe(async () => {
    var i;
    (i = a) == null || i.stop(), l.value = void 0, oe && t.isActive.value && e.locationStrategy && (a = dt(), e.locationStrategy !== "connected" && await ee(), a.run(() => {
      if (typeof e.locationStrategy == "function") {
        var r;
        l.value = (r = e.locationStrategy(t, e, n)) == null ? void 0 : r.updateLocation;
      } else {
        var c;
        l.value = (c = _l[e.locationStrategy](t, e, n)) == null ? void 0 : c.updateLocation;
      }
    }));
  }), oe && window.addEventListener("resize", o, {
    passive: !0
  }), se(() => {
    var i;
    oe && window.removeEventListener("resize", o), l.value = void 0, (i = a) == null || i.stop();
  });
  function o(i) {
    var r;
    (r = l.value) == null || r.call(l, i);
  }
  return {
    contentStyles: n,
    updateLocation: l
  };
}
function uo() {
}
function co(e) {
  const t = Wt(e);
  return t.x -= parseFloat(e.style.left || 0), t.y -= parseFloat(e.style.top || 0), t;
}
function vo(e, t, n) {
  const l = Sa(e.activatorEl.value);
  l && Object.assign(n.value, {
    position: "fixed"
  });
  const {
    preferredAnchor: a,
    preferredOrigin: o
  } = jt(() => {
    const p = Lt(t.location, e.isRtl.value), g = t.origin === "overlap" ? p : t.origin === "auto" ? xt(p) : Lt(t.origin, e.isRtl.value);
    return p.side === g.side && p.align === Vt(g).align ? {
      preferredAnchor: Sn(p),
      preferredOrigin: Sn(g)
    } : {
      preferredAnchor: p,
      preferredOrigin: g
    };
  }), [i, r, c, v] = ["minWidth", "minHeight", "maxWidth", "maxHeight"].map((p) => y(() => {
    const g = parseFloat(t[p]);
    return isNaN(g) ? 1 / 0 : g;
  })), f = y(() => {
    if (Array.isArray(t.offset))
      return t.offset;
    if (typeof t.offset == "string") {
      const p = t.offset.split(" ").map(parseFloat);
      return p.length < 2 && p.push(0), p;
    }
    return typeof t.offset == "number" ? [t.offset, 0] : [0, 0];
  });
  let d = !1;
  const u = new ResizeObserver(() => {
    d && m();
  });
  H([e.activatorEl, e.contentEl], (p, g) => {
    let [b, w] = p, [V, h] = g;
    V && u.unobserve(V), b && u.observe(b), h && u.unobserve(h), w && u.observe(w);
  }, {
    immediate: !0
  }), se(() => {
    u.disconnect();
  });
  function m() {
    if (d = !1, requestAnimationFrame(() => {
      requestAnimationFrame(() => d = !0);
    }), !e.activatorEl.value || !e.contentEl.value)
      return;
    const p = e.activatorEl.value.getBoundingClientRect(), g = co(e.contentEl.value), b = it(e.contentEl.value), w = 12;
    b.length || (b.push(document.documentElement), e.contentEl.value.style.top && e.contentEl.value.style.left || (g.x += parseFloat(document.documentElement.style.getPropertyValue("--v-body-scroll-x") || 0), g.y += parseFloat(document.documentElement.style.getPropertyValue("--v-body-scroll-y") || 0)));
    const V = b.reduce((k, $) => {
      const O = $.getBoundingClientRect(), E = new xe({
        x: $ === document.documentElement ? 0 : O.x,
        y: $ === document.documentElement ? 0 : O.y,
        width: $.clientWidth,
        height: $.clientHeight
      });
      return k ? new xe({
        x: Math.max(k.left, E.left),
        y: Math.max(k.top, E.top),
        width: Math.min(k.right, E.right) - Math.max(k.left, E.left),
        height: Math.min(k.bottom, E.bottom) - Math.max(k.top, E.top)
      }) : E;
    }, void 0);
    V.x += w, V.y += w, V.width -= w * 2, V.height -= w * 2;
    let h = {
      anchor: a.value,
      origin: o.value
    };
    function I(k) {
      const $ = new xe(g), O = Pn(k.anchor, p), E = Pn(k.origin, $);
      let {
        x: L,
        y: N
      } = io(O, E);
      switch (k.anchor.side) {
        case "top":
          N -= f.value[0];
          break;
        case "bottom":
          N += f.value[0];
          break;
        case "left":
          L -= f.value[0];
          break;
        case "right":
          L += f.value[0];
          break;
      }
      switch (k.anchor.align) {
        case "top":
          N -= f.value[1];
          break;
        case "bottom":
          N += f.value[1];
          break;
        case "left":
          L -= f.value[1];
          break;
        case "right":
          L += f.value[1];
          break;
      }
      return $.x += L, $.y += N, $.width = Math.min($.width, c.value), $.height = Math.min($.height, v.value), {
        overflows: _n($, V),
        x: L,
        y: N
      };
    }
    let x = 0, B = 0;
    const P = {
      x: 0,
      y: 0
    }, S = {
      x: !1,
      y: !1
    };
    let _ = -1;
    for (; ; ) {
      if (_++ > 10) {
        da("Infinite loop detected in connectedLocationStrategy");
        break;
      }
      const {
        x: k,
        y: $,
        overflows: O
      } = I(h);
      x += k, B += $, g.x += k, g.y += $;
      {
        const E = Cn(h.anchor), L = O.x.before || O.x.after, N = O.y.before || O.y.after;
        let T = !1;
        if (["x", "y"].forEach((F) => {
          if (F === "x" && L && !S.x || F === "y" && N && !S.y) {
            const D = {
              anchor: {
                ...h.anchor
              },
              origin: {
                ...h.origin
              }
            }, U = F === "x" ? E === "y" ? Vt : xt : E === "y" ? xt : Vt;
            D.anchor = U(D.anchor), D.origin = U(D.origin);
            const {
              overflows: Y
            } = I(D);
            (Y[F].before <= O[F].before && Y[F].after <= O[F].after || Y[F].before + Y[F].after < (O[F].before + O[F].after) / 2) && (h = D, T = S[F] = !0);
          }
        }), T)
          continue;
      }
      O.x.before && (x += O.x.before, g.x += O.x.before), O.x.after && (x -= O.x.after, g.x -= O.x.after), O.y.before && (B += O.y.before, g.y += O.y.before), O.y.after && (B -= O.y.after, g.y -= O.y.after);
      {
        const E = _n(g, V);
        P.x = V.width - E.x.before - E.x.after, P.y = V.height - E.y.before - E.y.after, x += E.x.before, g.x += E.x.before, B += E.y.before, g.y += E.y.before;
      }
      break;
    }
    const C = Cn(h.anchor);
    Object.assign(n.value, {
      "--v-overlay-anchor-origin": `${h.anchor.side} ${h.anchor.align}`,
      transformOrigin: `${h.origin.side} ${h.origin.align}`,
      // transform: `translate(${pixelRound(x)}px, ${pixelRound(y)}px)`,
      top: z(An(B)),
      left: z(An(x)),
      minWidth: z(C === "y" ? Math.min(i.value, p.width) : i.value),
      maxWidth: z(On(Bt(P.x, i.value === 1 / 0 ? 0 : i.value, c.value))),
      maxHeight: z(On(Bt(P.y, r.value === 1 / 0 ? 0 : r.value, v.value)))
    });
  }
  return H(() => [a.value, o.value, t.offset, t.minWidth, t.minHeight, t.maxWidth, t.maxHeight], () => m(), {
    immediate: !l
  }), l && ee(() => m()), requestAnimationFrame(() => {
    n.value.maxHeight && m();
  }), {
    updateLocation: m
  };
}
function An(e) {
  return Math.round(e * devicePixelRatio) / devicePixelRatio;
}
function On(e) {
  return Math.ceil(e * devicePixelRatio) / devicePixelRatio;
}
let Nt = !0;
const st = [];
function fo(e) {
  !Nt || st.length ? (st.push(e), Mt()) : (Nt = !1, e(), Mt());
}
let En = -1;
function Mt() {
  cancelAnimationFrame(En), En = requestAnimationFrame(() => {
    const e = st.shift();
    e && e(), st.length ? Mt() : Nt = !0;
  });
}
const zt = {
  none: null,
  close: yo,
  block: ho,
  reposition: po
}, mo = R({
  scrollStrategy: {
    type: [String, Function],
    default: "block",
    validator: (e) => typeof e == "function" || e in zt
  }
}, "v-overlay-scroll-strategies");
function go(e, t) {
  if (!oe)
    return;
  let n;
  Pe(async () => {
    var l;
    (l = n) == null || l.stop(), t.isActive.value && e.scrollStrategy && (n = dt(), await ee(), n.run(() => {
      if (typeof e.scrollStrategy == "function")
        e.scrollStrategy(t, e);
      else {
        var a;
        (a = zt[e.scrollStrategy]) == null || a.call(zt, t, e);
      }
    }));
  }), se(() => {
    var l;
    (l = n) == null || l.stop();
  });
}
function yo(e) {
  function t(n) {
    e.isActive.value = !1;
  }
  wl(e.activatorEl.value ?? e.contentEl.value, t);
}
function ho(e, t) {
  var n;
  const l = (n = e.root.value) == null ? void 0 : n.offsetParent, a = [.../* @__PURE__ */ new Set([...it(e.activatorEl.value, t.contained ? l : void 0), ...it(e.contentEl.value, t.contained ? l : void 0)])].filter((r) => !r.classList.contains("v-overlay-scroll-blocked")), o = window.innerWidth - document.documentElement.offsetWidth, i = ((r) => Ut(r) && r)(l || document.documentElement);
  i && e.root.value.classList.add("v-overlay--scroll-blocked"), a.forEach((r, c) => {
    r.style.setProperty("--v-body-scroll-x", z(-r.scrollLeft)), r.style.setProperty("--v-body-scroll-y", z(-r.scrollTop)), r.style.setProperty("--v-scrollbar-offset", z(o)), r.classList.add("v-overlay-scroll-blocked");
  }), se(() => {
    a.forEach((r, c) => {
      const v = parseFloat(r.style.getPropertyValue("--v-body-scroll-x")), f = parseFloat(r.style.getPropertyValue("--v-body-scroll-y"));
      r.style.removeProperty("--v-body-scroll-x"), r.style.removeProperty("--v-body-scroll-y"), r.style.removeProperty("--v-scrollbar-offset"), r.classList.remove("v-overlay-scroll-blocked"), r.scrollLeft = -v, r.scrollTop = -f;
    }), i && e.root.value.classList.remove("v-overlay--scroll-blocked");
  });
}
function po(e) {
  let t = !1, n = -1;
  function l(a) {
    fo(() => {
      var o, i;
      const r = performance.now();
      (o = (i = e.updateLocation).value) == null || o.call(i, a), t = (performance.now() - r) / (1e3 / 60) > 2;
    });
  }
  wl(e.activatorEl.value ?? e.contentEl.value, (a) => {
    t ? (cancelAnimationFrame(n), n = requestAnimationFrame(() => {
      n = requestAnimationFrame(() => {
        l(a);
      });
    })) : l(a);
  });
}
function wl(e, t) {
  const n = [document, ...it(e)];
  n.forEach((l) => {
    l.addEventListener("scroll", t, {
      passive: !0
    });
  }), se(() => {
    n.forEach((l) => {
      l.removeEventListener("scroll", t);
    });
  });
}
function bo() {
  var e, t;
  return (e = te("useRouter")) == null || (t = e.proxy) == null ? void 0 : t.$router;
}
function kl(e, t) {
  const n = na("RouterLink"), l = y(() => !!(e.href || e.to)), a = y(() => (l == null ? void 0 : l.value) || pn(t, "click") || pn(e, "click"));
  if (typeof n == "string")
    return {
      isLink: l,
      isClickable: a,
      href: j(e, "href")
    };
  const o = e.to ? n.useLink(e) : void 0;
  return {
    isLink: l,
    isClickable: a,
    route: o == null ? void 0 : o.route,
    navigate: o == null ? void 0 : o.navigate,
    isActive: o && y(() => {
      var i, r;
      return e.exact ? (i = o.isExactActive) == null ? void 0 : i.value : (r = o.isActive) == null ? void 0 : r.value;
    }),
    href: y(() => e.to ? o == null ? void 0 : o.route.value.href : e.href)
  };
}
const xl = R({
  href: String,
  replace: Boolean,
  to: [String, Object],
  exact: Boolean
}, "router");
let Ot = !1;
function So(e, t) {
  let n = !1, l, a;
  oe && (ee(() => {
    window.addEventListener("popstate", o), l = e == null ? void 0 : e.beforeEach((i, r, c) => {
      Ot ? n ? t(c) : c() : setTimeout(() => n ? t(c) : c()), Ot = !0;
    }), a = e == null ? void 0 : e.afterEach(() => {
      Ot = !1;
    });
  }), se(() => {
    var i, r;
    window.removeEventListener("popstate", o), (i = l) == null || i(), (r = a) == null || r();
  }));
  function o(i) {
    var r;
    (r = i.state) != null && r.replaced || (n = !0, setTimeout(() => n = !1));
  }
}
const Co = Symbol.for("vuetify:display");
function _o() {
  const e = X(Co);
  if (!e)
    throw new Error("Could not find Vuetify display injection");
  return e;
}
function wo() {
  if (!oe)
    return A(!1);
  const {
    ssr: e
  } = _o();
  if (e) {
    const t = A(!1);
    return Ue(() => {
      t.value = !0;
    }), t;
  } else
    return A(!0);
}
function un() {
  const t = te("useScopeId").vnode.scopeId;
  return {
    scopeId: t ? {
      [t]: ""
    } : void 0
  };
}
const Bn = Symbol.for("vuetify:stack"), Me = ct([]);
function ko(e, t, n) {
  const l = te("useStack"), a = !n, o = X(Bn, void 0), i = ct({
    activeChildren: /* @__PURE__ */ new Set()
  });
  re(Bn, i);
  const r = A(+t.value);
  Ve(e, () => {
    var f;
    const d = (f = Me.at(-1)) == null ? void 0 : f[1];
    r.value = d ? d + 10 : +t.value, a && Me.push([l.uid, r.value]), o == null || o.activeChildren.add(l.uid), se(() => {
      if (a) {
        const u = Me.findIndex((m) => m[0] === l.uid);
        Me.splice(u, 1);
      }
      o == null || o.activeChildren.delete(l.uid);
    });
  });
  const c = A(!0);
  a && Pe(() => {
    var f;
    const d = ((f = Me.at(-1)) == null ? void 0 : f[0]) === l.uid;
    setTimeout(() => c.value = d);
  });
  const v = y(() => !i.activeChildren.size);
  return {
    globalTop: la(c),
    localTop: v,
    stackStyles: y(() => ({
      zIndex: r.value
    }))
  };
}
function ze(e) {
  return {
    teleportTarget: y(() => {
      const n = e.value;
      if (n === !0 || !oe)
        return;
      const l = n === !1 ? document.body : typeof n == "string" ? document.querySelector(n) : n;
      if (l == null) {
        aa(`Unable to locate target ${n}`);
        return;
      }
      if (!ze.cache.has(l)) {
        const a = document.createElement("div");
        a.className = "v-overlay-container", l.appendChild(a), ze.cache.set(l, a);
      }
      return ze.cache.get(l);
    })
  };
}
ze.cache = /* @__PURE__ */ new WeakMap();
function xo() {
  return !0;
}
function Vl(e, t, n) {
  if (!e || $l(e, n) === !1)
    return !1;
  const l = Qn(t);
  if (typeof ShadowRoot < "u" && l instanceof ShadowRoot && l.host === e.target)
    return !1;
  const a = (typeof n.value == "object" && n.value.include || (() => []))();
  return a.push(t), !a.some((o) => o == null ? void 0 : o.contains(e.target));
}
function $l(e, t) {
  return (typeof t.value == "object" && t.value.closeConditional || xo)(e);
}
function Vo(e, t, n) {
  const l = typeof n.value == "function" ? n.value : n.value.handler;
  t._clickOutside.lastMousedownWasOutside && Vl(e, t, n) && setTimeout(() => {
    $l(e, n) && l && l(e);
  }, 0);
}
function Ln(e, t) {
  const n = Qn(e);
  t(document), typeof ShadowRoot < "u" && n instanceof ShadowRoot && t(n);
}
const $o = {
  // [data-app] may not be found
  // if using bind, inserted makes
  // sure that the root element is
  // available, iOS does not support
  // clicks on body
  mounted(e, t) {
    const n = (a) => Vo(a, e, t), l = (a) => {
      e._clickOutside.lastMousedownWasOutside = Vl(a, e, t);
    };
    Ln(e, (a) => {
      a.addEventListener("click", n, !0), a.addEventListener("mousedown", l, !0);
    }), e._clickOutside || (e._clickOutside = {
      lastMousedownWasOutside: !0
    }), e._clickOutside[t.instance.$.uid] = {
      onClick: n,
      onMousedown: l
    };
  },
  unmounted(e, t) {
    e._clickOutside && (Ln(e, (n) => {
      var l;
      if (!n || !((l = e._clickOutside) != null && l[t.instance.$.uid]))
        return;
      const {
        onClick: a,
        onMousedown: o
      } = e._clickOutside[t.instance.$.uid];
      n.removeEventListener("click", a, !0), n.removeEventListener("mousedown", o, !0);
    }), delete e._clickOutside[t.instance.$.uid]);
  }
};
function Io(e) {
  const {
    modelValue: t,
    color: n,
    ...l
  } = e;
  return s(Ce, {
    name: "fade-transition",
    appear: !0
  }, {
    default: () => [e.modelValue && s("div", M({
      class: ["v-overlay__scrim", e.color.backgroundColorClasses.value],
      style: e.color.backgroundColorStyles.value
    }, l), null)]
  });
}
const cn = R({
  absolute: Boolean,
  attach: [Boolean, String, Object],
  closeOnBack: {
    type: Boolean,
    default: !0
  },
  contained: Boolean,
  contentClass: null,
  contentProps: null,
  disabled: Boolean,
  noClickAnimation: Boolean,
  modelValue: Boolean,
  persistent: Boolean,
  scrim: {
    type: [String, Boolean],
    default: !0
  },
  zIndex: {
    type: [Number, String],
    default: 2e3
  },
  ...to(),
  ...pt(),
  ...ao(),
  ...ro(),
  ...mo(),
  ...ae(),
  ...Fe()
}, "v-overlay"), dn = ne()({
  name: "VOverlay",
  directives: {
    ClickOutside: $o
  },
  inheritAttrs: !1,
  props: {
    _disableGlobalStack: Boolean,
    ...cn()
  },
  emits: {
    "click:outside": (e) => !0,
    "update:modelValue": (e) => !0,
    afterLeave: () => !0
  },
  setup(e, t) {
    let {
      slots: n,
      attrs: l,
      emit: a
    } = t;
    const o = q(e, "modelValue"), i = y({
      get: () => o.value,
      set: (D) => {
        D && e.disabled || (o.value = D);
      }
    }), {
      teleportTarget: r
    } = ze(y(() => e.attach || e.contained)), {
      themeClasses: c
    } = ce(e), {
      rtlClasses: v,
      isRtl: f
    } = Jt(), {
      hasContent: d,
      onAfterLeave: u
    } = oo(e, i), m = $e(y(() => typeof e.scrim == "string" ? e.scrim : null)), {
      globalTop: p,
      localTop: g,
      stackStyles: b
    } = ko(i, j(e, "zIndex"), e._disableGlobalStack), {
      activatorEl: w,
      activatorRef: V,
      activatorEvents: h,
      contentEvents: I,
      scrimEvents: x
    } = no(e, {
      isActive: i,
      isTop: g
    }), {
      dimensionStyles: B
    } = bt(e), P = wo(), {
      scopeId: S
    } = un();
    H(() => e.disabled, (D) => {
      D && (i.value = !1);
    });
    const _ = A(), C = A(), {
      contentStyles: k,
      updateLocation: $
    } = so(e, {
      isRtl: f,
      contentEl: C,
      activatorEl: w,
      isActive: i
    });
    go(e, {
      root: _,
      contentEl: C,
      activatorEl: w,
      isActive: i,
      updateLocation: $
    });
    function O(D) {
      a("click:outside", D), e.persistent ? F() : i.value = !1;
    }
    function E() {
      return i.value && p.value;
    }
    oe && H(i, (D) => {
      D ? window.addEventListener("keydown", L) : window.removeEventListener("keydown", L);
    }, {
      immediate: !0
    });
    function L(D) {
      D.key === "Escape" && p.value && (e.persistent ? F() : i.value = !1);
    }
    const N = bo();
    Ve(() => e.closeOnBack, () => {
      So(N, (D) => {
        p.value && i.value ? (D(!1), e.persistent ? F() : i.value = !1) : D();
      });
    });
    const T = A();
    H(() => i.value && (e.absolute || e.contained) && r.value == null, (D) => {
      if (D) {
        const U = ba(_.value);
        U && U !== document.scrollingElement && (T.value = U.scrollTop);
      }
    });
    function F() {
      e.noClickAnimation || C.value && ke(C.value, [{
        transformOrigin: "center"
      }, {
        transform: "scale(1.03)"
      }, {
        transformOrigin: "center"
      }], {
        duration: 150,
        easing: ot
      });
    }
    return W(() => {
      var D, U;
      return s(Z, null, [(D = n.activator) == null ? void 0 : D.call(n, {
        isActive: i.value,
        props: M({
          ref: V
        }, kt(h.value), e.activatorProps)
      }), P.value && s(oa, {
        disabled: !r.value,
        to: r.value
      }, {
        default: () => [d.value && s("div", M({
          class: ["v-overlay", {
            "v-overlay--absolute": e.absolute || e.contained,
            "v-overlay--active": i.value,
            "v-overlay--contained": e.contained
          }, c.value, v.value],
          style: [b.value, {
            top: z(T.value)
          }],
          ref: _
        }, S, l), [s(Io, M({
          color: m,
          modelValue: i.value && !!e.scrim
        }, kt(x.value)), null), s(pe, {
          appear: !0,
          persisted: !0,
          transition: e.transition,
          target: w.value,
          onAfterLeave: () => {
            u(), a("afterLeave");
          }
        }, {
          default: () => [Q(s("div", M({
            ref: C,
            class: ["v-overlay__content", e.contentClass],
            style: [B.value, k.value]
          }, kt(I.value), e.contentProps), [(U = n.default) == null ? void 0 : U.call(n, {
            isActive: i
          })]), [[Oe, i.value], [we("click-outside"), {
            handler: O,
            closeConditional: E,
            include: () => [w.value]
          }]])]
        })])]
      })]);
    }), {
      activatorEl: w,
      animateClick: F,
      contentEl: C,
      globalTop: p,
      localTop: g,
      updateLocation: $
    };
  }
});
function Il(e) {
  return fe(e, Object.keys(dn.props));
}
const Po = ["elevated", "flat", "tonal", "outlined", "text", "plain"];
function St(e, t) {
  return s(Z, null, [e && s("span", {
    key: "overlay",
    class: `${t}__overlay`
  }, null), s("span", {
    key: "underlay",
    class: `${t}__underlay`
  }, null)]);
}
const Ne = R({
  color: String,
  variant: {
    type: String,
    default: "elevated",
    validator: (e) => Po.includes(e)
  }
}, "variant");
function Ct(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ge();
  const n = y(() => {
    const {
      variant: o
    } = be(e);
    return `${t}--variant-${o}`;
  }), {
    colorClasses: l,
    colorStyles: a
  } = Xt(y(() => {
    const {
      variant: o,
      color: i
    } = be(e);
    return {
      [["elevated", "flat"].includes(o) ? "background" : "text"]: i
    };
  }));
  return {
    colorClasses: l,
    colorStyles: a,
    variantClasses: n
  };
}
const Fn = {
  center: "center",
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, Ao = R({
  location: String
}, "location");
function Oo(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, n = arguments.length > 2 ? arguments[2] : void 0;
  const {
    isRtl: l
  } = Jt();
  return {
    locationStyles: y(() => {
      if (!e.location)
        return {};
      const {
        side: o,
        align: i
      } = Lt(e.location.split(" ").length > 1 ? e.location : `${e.location} center`, l.value);
      function r(v) {
        return n ? n(v) : 0;
      }
      const c = {};
      return o !== "center" && (t ? c[Fn[o]] = `calc(100% - ${r(o)}px)` : c[o] = 0), i !== "center" ? t ? c[Fn[i]] = `calc(100% - ${r(i)}px)` : c[i] = 0 : (o === "center" ? c.top = c.left = "50%" : c[{
        top: "left",
        bottom: "left",
        left: "top",
        right: "top"
      }[o]] = "50%", c.transform = {
        top: "translateX(-50%)",
        bottom: "translateX(-50%)",
        left: "translateY(-50%)",
        right: "translateY(-50%)",
        center: "translate(-50%, -50%)"
      }[o]), c;
    })
  };
}
const Eo = ["static", "relative", "fixed", "absolute", "sticky"], Bo = R({
  position: {
    type: String,
    validator: (
      /* istanbul ignore next */
      (e) => Eo.includes(e)
    )
  }
}, "position");
function Lo(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ge();
  return {
    positionClasses: y(() => e.position ? `${t}--${e.position}` : void 0)
  };
}
const Fo = ne()({
  name: "VSnackbar",
  props: {
    multiLine: Boolean,
    timeout: {
      type: [Number, String],
      default: 5e3
    },
    vertical: Boolean,
    ...Ao({
      location: "bottom"
    }),
    ...Bo(),
    ...Be(),
    ...Ne(),
    ...ae(),
    ...qe(cn({
      transition: "v-snackbar-transition"
    }), ["persistent", "noClickAnimation", "scrim", "scrollStrategy"])
  },
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const l = q(e, "modelValue"), {
      locationStyles: a
    } = Oo(e), {
      positionClasses: o
    } = Lo(e), {
      scopeId: i
    } = un(), {
      themeClasses: r
    } = ce(e), {
      colorClasses: c,
      colorStyles: v,
      variantClasses: f
    } = Ct(e), {
      roundedClasses: d
    } = Le(e), u = A();
    H(l, p), H(() => e.timeout, p), Ue(() => {
      l.value && p();
    });
    let m = -1;
    function p() {
      window.clearTimeout(m);
      const b = Number(e.timeout);
      !l.value || b === -1 || (m = window.setTimeout(() => {
        l.value = !1;
      }, b));
    }
    function g() {
      window.clearTimeout(m);
    }
    return W(() => {
      const [b] = Il(e);
      return s(dn, M({
        ref: u,
        class: ["v-snackbar", {
          "v-snackbar--active": l.value,
          "v-snackbar--multi-line": e.multiLine && !e.vertical,
          "v-snackbar--vertical": e.vertical
        }, o.value]
      }, b, {
        modelValue: l.value,
        "onUpdate:modelValue": (w) => l.value = w,
        contentProps: M({
          style: a.value
        }, b.contentProps),
        persistent: !0,
        noClickAnimation: !0,
        scrim: !1,
        scrollStrategy: "none"
      }, i), {
        default: () => [s("div", {
          class: ["v-snackbar__wrapper", r.value, c.value, d.value, f.value],
          style: [v.value],
          onPointerenter: g,
          onPointerleave: p
        }, [St(!1, "v-snackbar"), n.default && s("div", {
          class: "v-snackbar__content",
          role: "status",
          "aria-live": "polite"
        }, [n.default()]), n.actions && s(ie, {
          defaults: {
            VBtn: {
              variant: "text",
              ripple: !1
            }
          }
        }, {
          default: () => [s("div", {
            class: "v-snackbar__actions"
          }, [n.actions()])]
        })])],
        activator: n.activator
      });
    }), Re({}, u);
  }
});
const To = G({
  name: "VTextarea",
  directives: {
    Intersect: nn
  },
  inheritAttrs: !1,
  props: {
    autoGrow: Boolean,
    autofocus: Boolean,
    counter: [Boolean, Number, String],
    counterValue: Function,
    hint: String,
    persistentHint: Boolean,
    prefix: String,
    placeholder: String,
    persistentPlaceholder: Boolean,
    persistentCounter: Boolean,
    noResize: Boolean,
    rows: {
      type: [Number, String],
      default: 5,
      validator: (e) => !isNaN(parseFloat(e))
    },
    maxRows: {
      type: [Number, String],
      validator: (e) => !isNaN(parseFloat(e))
    },
    suffix: String,
    ...Ze(),
    ...en()
  },
  emits: {
    "click:control": (e) => !0,
    "update:focused": (e) => !0,
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      emit: l,
      slots: a
    } = t;
    const o = q(e, "modelValue"), {
      isFocused: i,
      focus: r,
      blur: c
    } = mt(e), v = y(() => typeof e.counterValue == "function" ? e.counterValue(o.value) : (o.value || "").toString().length), f = y(() => {
      if (n.maxlength)
        return n.maxlength;
      if (!(!e.counter || typeof e.counter != "number" && typeof e.counter != "string"))
        return e.counter;
    });
    function d(_, C) {
      var k, $;
      !e.autofocus || !_ || (k = C[0].target) == null || ($ = k.focus) == null || $.call(k);
    }
    const u = A(), m = A(), p = A(""), g = A(), b = y(() => i.value || e.persistentPlaceholder), w = y(() => e.messages.length ? e.messages : b.value || e.persistentHint ? e.hint : "");
    function V() {
      if (g.value !== document.activeElement) {
        var _;
        (_ = g.value) == null || _.focus();
      }
      i.value || r();
    }
    function h(_) {
      V(), l("click:control", _);
    }
    function I(_) {
      _.stopPropagation(), V(), ee(() => {
        o.value = "", Un(e["onClick:clear"], _);
      });
    }
    function x(_) {
      o.value = _.target.value;
    }
    const B = A();
    function P() {
      e.autoGrow && ee(() => {
        if (!B.value || !m.value)
          return;
        const _ = getComputedStyle(B.value), C = getComputedStyle(m.value.$el), k = parseFloat(_.getPropertyValue("--v-field-padding-top")) + parseFloat(_.getPropertyValue("--v-input-padding-top")) + parseFloat(_.getPropertyValue("--v-field-padding-bottom")), $ = B.value.scrollHeight, O = parseFloat(_.lineHeight), E = Math.max(parseFloat(e.rows) * O + k, parseFloat(C.getPropertyValue("--v-input-control-height"))), L = parseFloat(e.maxRows) * O + k || 1 / 0;
        p.value = z(Bt($ ?? 0, E, L));
      });
    }
    Ue(P), H(o, P), H(() => e.rows, P), H(() => e.maxRows, P), H(() => e.density, P);
    let S;
    return H(B, (_) => {
      if (_)
        S = new ResizeObserver(P), S.observe(B.value);
      else {
        var C;
        (C = S) == null || C.disconnect();
      }
    }), _e(() => {
      var _;
      (_ = S) == null || _.disconnect();
    }), W(() => {
      const _ = !!(a.counter || e.counter || e.counterValue), C = !!(_ || a.details), [k, $] = Ye(n), [{
        modelValue: O,
        ...E
      }] = gt(e), [L] = sl(e);
      return s(Je, M({
        ref: u,
        modelValue: o.value,
        "onUpdate:modelValue": (N) => o.value = N,
        class: ["v-textarea v-text-field", {
          "v-textarea--prefixed": e.prefix,
          "v-textarea--suffixed": e.suffix,
          "v-text-field--prefixed": e.prefix,
          "v-text-field--suffixed": e.suffix,
          "v-textarea--auto-grow": e.autoGrow,
          "v-textarea--no-resize": e.noResize || e.autoGrow,
          "v-text-field--flush-details": ["plain", "underlined"].includes(e.variant)
        }],
        "onClick:prepend": e["onClick:prepend"],
        "onClick:append": e["onClick:append"]
      }, k, E, {
        focused: i.value,
        messages: w.value
      }), {
        ...a,
        default: (N) => {
          let {
            isDisabled: T,
            isDirty: F,
            isReadonly: D,
            isValid: U
          } = N;
          return s(tn, M({
            ref: m,
            style: {
              "--v-textarea-control-height": p.value
            },
            "onClick:control": h,
            "onClick:clear": I,
            "onClick:prependInner": e["onClick:prependInner"],
            "onClick:appendInner": e["onClick:appendInner"],
            role: "textbox"
          }, L, {
            active: b.value || F.value,
            dirty: F.value || e.dirty,
            focused: i.value,
            error: U.value === !1
          }), {
            ...a,
            default: (Y) => {
              let {
                props: {
                  class: he,
                  ...Qe
                }
              } = Y;
              return s(Z, null, [e.prefix && s("span", {
                class: "v-text-field__prefix"
              }, [e.prefix]), Q(s("textarea", M({
                ref: g,
                class: he,
                value: o.value,
                onInput: x,
                autofocus: e.autofocus,
                readonly: D.value,
                disabled: T.value,
                placeholder: e.placeholder,
                rows: e.rows,
                name: e.name,
                onFocus: V,
                onBlur: c
              }, Qe, $), null), [[we("intersect"), {
                handler: d
              }, null, {
                once: !0
              }]]), e.autoGrow && Q(s("textarea", {
                class: [he, "v-textarea__sizer"],
                "onUpdate:modelValue": (_t) => o.value = _t,
                ref: B,
                readonly: !0,
                "aria-hidden": "true"
              }, null), [[ia, o.value]]), e.suffix && s("span", {
                class: "v-text-field__suffix"
              }, [e.suffix])]);
            }
          });
        },
        details: C ? (N) => {
          var T;
          return s(Z, null, [(T = a.details) == null ? void 0 : T.call(a, N), _ && s(Z, null, [s("span", null, null), s(ul, {
            active: e.persistentCounter || i.value,
            value: v.value,
            max: f.value
          }, a.counter)])]);
        } : void 0
      });
    }), Re({}, u, m, g);
  }
});
function Do(e) {
  return {
    aspectStyles: y(() => {
      const t = Number(e.aspectRatio);
      return t ? {
        paddingBottom: String(1 / t * 100) + "%"
      } : void 0;
    })
  };
}
const Ro = G({
  name: "VResponsive",
  props: {
    aspectRatio: [String, Number],
    contentClass: String,
    ...pt()
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      aspectStyles: l
    } = Do(e), {
      dimensionStyles: a
    } = bt(e);
    return W(() => {
      var o;
      return s("div", {
        class: "v-responsive",
        style: a.value
      }, [s("div", {
        class: "v-responsive__sizer",
        style: l.value
      }, null), (o = n.additional) == null ? void 0 : o.call(n), n.default && s("div", {
        class: ["v-responsive__content", e.contentClass]
      }, [n.default()])]);
    }), {};
  }
}), No = G({
  name: "VImg",
  directives: {
    intersect: nn
  },
  props: {
    aspectRatio: [String, Number],
    alt: String,
    cover: Boolean,
    eager: Boolean,
    gradient: String,
    lazySrc: String,
    options: {
      type: Object,
      // For more information on types, navigate to:
      // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      default: () => ({
        root: void 0,
        rootMargin: void 0,
        threshold: void 0
      })
    },
    sizes: String,
    src: {
      type: [String, Object],
      default: ""
    },
    srcset: String,
    width: [String, Number],
    ...Fe()
  },
  emits: {
    loadstart: (e) => !0,
    load: (e) => !0,
    error: (e) => !0
  },
  setup(e, t) {
    let {
      emit: n,
      slots: l
    } = t;
    const a = A(""), o = A(), i = A(e.eager ? "loading" : "idle"), r = A(), c = A(), v = y(() => e.src && typeof e.src == "object" ? {
      src: e.src.src,
      srcset: e.srcset || e.src.srcset,
      lazySrc: e.lazySrc || e.src.lazySrc,
      aspect: Number(e.aspectRatio || e.src.aspect || 0)
    } : {
      src: e.src,
      srcset: e.srcset,
      lazySrc: e.lazySrc,
      aspect: Number(e.aspectRatio || 0)
    }), f = y(() => v.value.aspect || r.value / c.value || 0);
    H(() => e.src, () => {
      d(i.value !== "idle");
    }), H(f, (S, _) => {
      !S && _ && o.value && b(o.value);
    }), zn(() => d());
    function d(S) {
      if (!(e.eager && S) && !(Kt && !S && !e.eager)) {
        if (i.value = "loading", v.value.lazySrc) {
          const _ = new Image();
          _.src = v.value.lazySrc, b(_, null);
        }
        v.value.src && ee(() => {
          var _, C;
          if (n("loadstart", ((_ = o.value) == null ? void 0 : _.currentSrc) || v.value.src), (C = o.value) != null && C.complete) {
            if (o.value.naturalWidth || m(), i.value === "error")
              return;
            f.value || b(o.value, null), u();
          } else
            f.value || b(o.value), p();
        });
      }
    }
    function u() {
      var S;
      p(), i.value = "loaded", n("load", ((S = o.value) == null ? void 0 : S.currentSrc) || v.value.src);
    }
    function m() {
      var S;
      i.value = "error", n("error", ((S = o.value) == null ? void 0 : S.currentSrc) || v.value.src);
    }
    function p() {
      const S = o.value;
      S && (a.value = S.currentSrc || S.src);
    }
    let g = -1;
    function b(S) {
      let _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
      const C = () => {
        clearTimeout(g);
        const {
          naturalHeight: k,
          naturalWidth: $
        } = S;
        k || $ ? (r.value = $, c.value = k) : !S.complete && i.value === "loading" && _ != null ? g = window.setTimeout(C, _) : (S.currentSrc.endsWith(".svg") || S.currentSrc.startsWith("data:image/svg+xml")) && (r.value = 1, c.value = 1);
      };
      C();
    }
    const w = y(() => ({
      "v-img__img--cover": e.cover,
      "v-img__img--contain": !e.cover
    })), V = () => {
      var S;
      if (!v.value.src || i.value === "idle")
        return null;
      const _ = s("img", {
        class: ["v-img__img", w.value],
        src: v.value.src,
        srcset: v.value.srcset,
        alt: "",
        sizes: e.sizes,
        ref: o,
        onLoad: u,
        onError: m
      }, null), C = (S = l.sources) == null ? void 0 : S.call(l);
      return s(pe, {
        transition: e.transition,
        appear: !0
      }, {
        default: () => [Q(C ? s("picture", {
          class: "v-img__picture"
        }, [C, _]) : _, [[Oe, i.value === "loaded"]])]
      });
    }, h = () => s(pe, {
      transition: e.transition
    }, {
      default: () => [v.value.lazySrc && i.value !== "loaded" && s("img", {
        class: ["v-img__img", "v-img__img--preload", w.value],
        src: v.value.lazySrc,
        alt: ""
      }, null)]
    }), I = () => l.placeholder ? s(pe, {
      transition: e.transition,
      appear: !0
    }, {
      default: () => [(i.value === "loading" || i.value === "error" && !l.error) && s("div", {
        class: "v-img__placeholder"
      }, [l.placeholder()])]
    }) : null, x = () => l.error ? s(pe, {
      transition: e.transition,
      appear: !0
    }, {
      default: () => [i.value === "error" && s("div", {
        class: "v-img__error"
      }, [l.error()])]
    }) : null, B = () => e.gradient ? s("div", {
      class: "v-img__gradient",
      style: {
        backgroundImage: `linear-gradient(${e.gradient})`
      }
    }, null) : null, P = A(!1);
    {
      const S = H(f, (_) => {
        _ && (requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            P.value = !0;
          });
        }), S());
      });
    }
    return W(() => Q(s(Ro, {
      class: ["v-img", {
        "v-img--booting": !P.value
      }],
      style: {
        width: z(e.width === "auto" ? r.value : e.width)
      },
      aspectRatio: f.value,
      "aria-label": e.alt,
      role: e.alt ? "img" : void 0
    }, {
      additional: () => s(Z, null, [s(V, null, null), s(h, null, null), s(B, null, null), s(I, null, null), s(x, null, null)]),
      default: l.default
    }), [[we("intersect"), {
      handler: d,
      options: e.options
    }, null, {
      once: !0
    }]])), {
      currentSrc: a,
      image: o,
      state: i,
      naturalWidth: r,
      naturalHeight: c
    };
  }
}), Mo = R({
  start: Boolean,
  end: Boolean,
  icon: K,
  image: String,
  ...Te(),
  ...Be(),
  ...qt(),
  ...ye(),
  ...ae(),
  ...Ne({
    variant: "flat"
  })
}, "v-avatar"), ut = G({
  name: "VAvatar",
  props: Mo(),
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: l
    } = ce(e), {
      colorClasses: a,
      colorStyles: o,
      variantClasses: i
    } = Ct(e), {
      densityClasses: r
    } = De(e), {
      roundedClasses: c
    } = Le(e), {
      sizeClasses: v,
      sizeStyles: f
    } = Yt(e);
    return W(() => {
      var d;
      return s(e.tag, {
        class: ["v-avatar", {
          "v-avatar--start": e.start,
          "v-avatar--end": e.end
        }, l.value, a.value, r.value, c.value, v.value, i.value],
        style: [o.value, f.value]
      }, {
        default: () => [e.image ? s(No, {
          key: "image",
          src: e.image,
          alt: ""
        }, null) : e.icon ? s(me, {
          key: "icon",
          icon: e.icon
        }, null) : (d = n.default) == null ? void 0 : d.call(n), St(!1, "v-avatar")]
      });
    }), {};
  }
});
const zo = R({
  modelValue: {
    type: null,
    default: void 0
  },
  multiple: Boolean,
  mandatory: [Boolean, String],
  max: Number,
  selectedClass: String,
  disabled: Boolean
}, "group"), Ho = R({
  value: null,
  disabled: Boolean,
  selectedClass: String
}, "group-item");
function jo(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  const l = te("useGroupItem");
  if (!l)
    throw new Error("[Vuetify] useGroupItem composable must be used inside a component setup function");
  const a = ue();
  re(Symbol.for(`${t.description}:id`), a);
  const o = X(t, null);
  if (!o) {
    if (!n)
      return o;
    throw new Error(`[Vuetify] Could not find useGroup injection with symbol ${t.description}`);
  }
  const i = j(e, "value"), r = y(() => o.disabled.value || e.disabled);
  o.register({
    id: a,
    value: i,
    disabled: r
  }, l), _e(() => {
    o.unregister(a);
  });
  const c = y(() => o.isSelected(a)), v = y(() => c.value && [o.selectedClass.value, e.selectedClass]);
  return H(c, (f) => {
    l.emit("group:selected", {
      value: f
    });
  }), {
    id: a,
    isSelected: c,
    toggle: () => o.select(a, !c.value),
    select: (f) => o.select(a, f),
    selectedClass: v,
    value: i,
    disabled: r,
    group: o
  };
}
function Wo(e, t) {
  let n = !1;
  const l = ct([]), a = q(e, "modelValue", [], (u) => u == null ? [] : Pl(l, ve(u)), (u) => {
    const m = Uo(l, u);
    return e.multiple ? m : m[0];
  }), o = te("useGroup");
  function i(u, m) {
    const p = u, g = Symbol.for(`${t.description}:id`), w = tt(g, o == null ? void 0 : o.vnode).indexOf(m);
    w > -1 ? l.splice(w, 0, p) : l.push(p);
  }
  function r(u) {
    if (n)
      return;
    c();
    const m = l.findIndex((p) => p.id === u);
    l.splice(m, 1);
  }
  function c() {
    const u = l.find((m) => !m.disabled);
    u && e.mandatory === "force" && !a.value.length && (a.value = [u.id]);
  }
  Ue(() => {
    c();
  }), _e(() => {
    n = !0;
  });
  function v(u, m) {
    const p = l.find((g) => g.id === u);
    if (!(m && p != null && p.disabled))
      if (e.multiple) {
        const g = a.value.slice(), b = g.findIndex((V) => V === u), w = ~b;
        if (m = m ?? !w, w && e.mandatory && g.length <= 1 || !w && e.max != null && g.length + 1 > e.max)
          return;
        b < 0 && m ? g.push(u) : b >= 0 && !m && g.splice(b, 1), a.value = g;
      } else {
        const g = a.value.includes(u);
        if (e.mandatory && g)
          return;
        a.value = m ?? !g ? [u] : [];
      }
  }
  function f(u) {
    if (e.multiple && Yn('This method is not supported when using "multiple" prop'), a.value.length) {
      const m = a.value[0], p = l.findIndex((w) => w.id === m);
      let g = (p + u) % l.length, b = l[g];
      for (; b.disabled && g !== p; )
        g = (g + u) % l.length, b = l[g];
      if (b.disabled)
        return;
      a.value = [l[g].id];
    } else {
      const m = l.find((p) => !p.disabled);
      m && (a.value = [m.id]);
    }
  }
  const d = {
    register: i,
    unregister: r,
    selected: a,
    select: v,
    disabled: j(e, "disabled"),
    prev: () => f(l.length - 1),
    next: () => f(1),
    isSelected: (u) => a.value.includes(u),
    selectedClass: y(() => e.selectedClass),
    items: y(() => l),
    getItemIndex: (u) => Go(l, u)
  };
  return re(t, d), d;
}
function Go(e, t) {
  const n = Pl(e, [t]);
  return n.length ? e.findIndex((l) => l.id === n[0]) : -1;
}
function Pl(e, t) {
  const n = [];
  for (let l = 0; l < e.length; l++) {
    const a = e[l];
    a.value != null ? t.find((o) => Ke(o, a.value)) != null && n.push(a.id) : t.includes(l) && n.push(a.id);
  }
  return n;
}
function Uo(e, t) {
  const n = [];
  for (let l = 0; l < e.length; l++) {
    const a = e[l];
    t.includes(a.id) && n.push(a.value != null ? a.value : l);
  }
  return n;
}
const Al = Symbol.for("vuetify:v-chip-group");
G({
  name: "VChipGroup",
  props: {
    column: Boolean,
    filter: Boolean,
    valueComparator: {
      type: Function,
      default: Ke
    },
    ...zo({
      selectedClass: "v-chip--selected"
    }),
    ...ye(),
    ...ae(),
    ...Ne({
      variant: "tonal"
    })
  },
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      themeClasses: l
    } = ce(e), {
      isSelected: a,
      select: o,
      next: i,
      prev: r,
      selected: c
    } = Wo(e, Al);
    return Xe({
      VChip: {
        color: j(e, "color"),
        filter: j(e, "filter"),
        variant: j(e, "variant")
      }
    }), W(() => {
      var v;
      return s(e.tag, {
        class: ["v-chip-group", {
          "v-chip-group--column": e.column
        }, l.value]
      }, {
        default: () => [(v = n.default) == null ? void 0 : v.call(n, {
          isSelected: a,
          select: o,
          next: i,
          prev: r,
          selected: c.value
        })]
      });
    }), {};
  }
});
const vn = R({
  border: [Boolean, Number, String]
}, "border");
function fn(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ge();
  return {
    borderClasses: y(() => {
      const l = Ae(e) ? e.value : e.border, a = [];
      if (l === !0 || l === "")
        a.push(`${t}--border`);
      else if (typeof l == "string" || l === 0)
        for (const o of String(l).split(" "))
          a.push(`border-${o}`);
      return a;
    })
  };
}
const mn = R({
  elevation: {
    type: [Number, String],
    validator(e) {
      const t = parseInt(e);
      return !isNaN(t) && t >= 0 && // Material Design has a maximum elevation of 24
      // https://material.io/design/environment/elevation.html#default-elevations
      t <= 24;
    }
  }
}, "elevation");
function gn(e) {
  return {
    elevationClasses: y(() => {
      const n = Ae(e) ? e.value : e.elevation, l = [];
      return n == null || l.push(`elevation-${n}`), l;
    })
  };
}
const Ol = G({
  name: "VChip",
  directives: {
    Ripple: on
  },
  props: {
    activeClass: String,
    appendAvatar: String,
    appendIcon: K,
    closable: Boolean,
    closeIcon: {
      type: K,
      default: "$delete"
    },
    closeLabel: {
      type: String,
      default: "$vuetify.close"
    },
    draggable: Boolean,
    filter: Boolean,
    filterIcon: {
      type: String,
      default: "$complete"
    },
    label: Boolean,
    link: Boolean,
    pill: Boolean,
    prependAvatar: String,
    prependIcon: K,
    ripple: {
      type: Boolean,
      default: !0
    },
    text: String,
    modelValue: {
      type: Boolean,
      default: !0
    },
    ...vn(),
    ...Te(),
    ...mn(),
    ...Ho(),
    ...Be(),
    ...xl(),
    ...qt(),
    ...ye({
      tag: "span"
    }),
    ...ae(),
    ...Ne({
      variant: "tonal"
    })
  },
  emits: {
    "click:close": (e) => !0,
    "update:modelValue": (e) => !0,
    "group:selected": (e) => !0,
    click: (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      emit: l,
      slots: a
    } = t;
    const {
      borderClasses: o
    } = fn(e), {
      colorClasses: i,
      colorStyles: r,
      variantClasses: c
    } = Ct(e), {
      densityClasses: v
    } = De(e), {
      elevationClasses: f
    } = gn(e), {
      roundedClasses: d
    } = Le(e), {
      sizeClasses: u
    } = Yt(e), {
      themeClasses: m
    } = ce(e), p = q(e, "modelValue"), g = jo(e, Al, !1), b = kl(e, n), w = y(() => !e.disabled && (!!g || b.isClickable.value || e.link));
    function V(I) {
      p.value = !1, l("click:close", I);
    }
    function h(I) {
      var x;
      l("click", I), w.value && ((x = b.navigate) == null || x.call(b, I), g == null || g.toggle());
    }
    return () => {
      var I;
      const x = b.isLink.value ? "a" : e.tag, B = !!(a.append || e.appendIcon || e.appendAvatar), P = !!(a.close || e.closable), S = !!(a.filter || e.filter) && g, _ = !!(a.prepend || e.prependIcon || e.prependAvatar), C = !g || g.isSelected.value;
      return p.value && Q(s(x, {
        class: ["v-chip", {
          "v-chip--disabled": e.disabled,
          "v-chip--label": e.label,
          "v-chip--link": w.value,
          "v-chip--filter": S,
          "v-chip--pill": e.pill
        }, m.value, o.value, C ? i.value : void 0, v.value, f.value, d.value, u.value, c.value, g == null ? void 0 : g.selectedClass.value],
        style: [C ? r.value : void 0],
        disabled: e.disabled || void 0,
        draggable: e.draggable,
        href: b.href.value,
        onClick: h
      }, {
        default: () => [St(w.value, "v-chip"), S && s(ie, {
          key: "filter",
          defaults: {
            VIcon: {
              icon: e.filterIcon
            }
          }
        }, {
          default: () => [s(al, null, {
            default: () => [Q(s("div", {
              class: "v-chip__filter"
            }, [a.filter ? a.filter() : s(me, null, null)]), [[Oe, g.isSelected.value]])]
          })]
        }), _ && s(ie, {
          key: "prepend",
          defaults: {
            VAvatar: {
              image: e.prependAvatar
            },
            VIcon: {
              icon: e.prependIcon
            }
          }
        }, {
          default: () => [a.prepend ? s("div", {
            class: "v-chip__prepend"
          }, [a.prepend()]) : e.prependAvatar ? s(ut, {
            start: !0
          }, null) : e.prependIcon ? s(me, {
            start: !0
          }, null) : void 0]
        }), ((I = a.default) == null ? void 0 : I.call(a, {
          isSelected: g == null ? void 0 : g.isSelected.value,
          selectedClass: g == null ? void 0 : g.selectedClass.value,
          select: g == null ? void 0 : g.select,
          toggle: g == null ? void 0 : g.toggle,
          value: g == null ? void 0 : g.value.value,
          disabled: e.disabled
        })) ?? e.text, B && s(ie, {
          key: "append",
          defaults: {
            VAvatar: {
              image: e.appendAvatar
            },
            VIcon: {
              icon: e.appendIcon
            }
          }
        }, {
          default: () => [a.append ? s("div", {
            class: "v-chip__append"
          }, [a.append()]) : e.appendAvatar ? s(ut, {
            end: !0
          }, null) : e.appendIcon ? s(me, {
            end: !0
          }, null) : void 0]
        }), P && s(ie, {
          key: "close",
          defaults: {
            VIcon: {
              icon: e.closeIcon,
              size: "x-small"
            }
          }
        }, {
          default: () => [s("div", {
            class: "v-chip__close",
            onClick: V
          }, [a.close ? a.close() : s(me, null, null)])]
        })]
      }), [[we("ripple"), w.value && e.ripple, null]]);
    };
  }
});
const Ko = G({
  name: "VDivider",
  props: {
    color: String,
    inset: Boolean,
    length: [Number, String],
    thickness: [Number, String],
    vertical: Boolean,
    ...ae()
  },
  setup(e, t) {
    let {
      attrs: n
    } = t;
    const {
      themeClasses: l
    } = ce(e), {
      backgroundColorClasses: a,
      backgroundColorStyles: o
    } = $e(j(e, "color")), i = y(() => {
      const r = {};
      return e.length && (r[e.vertical ? "maxHeight" : "maxWidth"] = z(e.length)), e.thickness && (r[e.vertical ? "borderRightWidth" : "borderTopWidth"] = z(e.thickness)), r;
    });
    return W(() => s("hr", {
      class: [{
        "v-divider": !0,
        "v-divider--inset": e.inset,
        "v-divider--vertical": e.vertical
      }, l.value, a.value],
      style: [i.value, o.value],
      "aria-orientation": !n.role || n.role === "separator" ? e.vertical ? "vertical" : "horizontal" : void 0,
      role: `${n.role || "separator"}`
    }, null)), {};
  }
}), Ht = Symbol.for("vuetify:list");
function El() {
  const e = X(Ht, {
    hasPrepend: A(!1),
    updateHasPrepend: () => null
  }), t = {
    hasPrepend: A(!1),
    updateHasPrepend: (n) => {
      n && (t.hasPrepend.value = n);
    }
  };
  return re(Ht, t), e;
}
function Bl() {
  return X(Ht, null);
}
const qo = {
  open: (e) => {
    let {
      id: t,
      value: n,
      opened: l,
      parents: a
    } = e;
    if (n) {
      const o = /* @__PURE__ */ new Set();
      o.add(t);
      let i = a.get(t);
      for (; i != null; )
        o.add(i), i = a.get(i);
      return o;
    } else
      return l.delete(t), l;
  },
  select: () => null
}, Ll = {
  open: (e) => {
    let {
      id: t,
      value: n,
      opened: l,
      parents: a
    } = e;
    if (n) {
      let o = a.get(t);
      for (l.add(t); o != null && o !== t; )
        l.add(o), o = a.get(o);
      return l;
    } else
      l.delete(t);
    return l;
  },
  select: () => null
}, Yo = {
  open: Ll.open,
  select: (e) => {
    let {
      id: t,
      value: n,
      opened: l,
      parents: a
    } = e;
    if (!n)
      return l;
    const o = [];
    let i = a.get(t);
    for (; i != null; )
      o.push(i), i = a.get(i);
    return new Set(o);
  }
}, yn = (e) => {
  const t = {
    select: (n) => {
      let {
        id: l,
        value: a,
        selected: o
      } = n;
      if (e && !a) {
        const i = Array.from(o.entries()).reduce((r, c) => {
          let [v, f] = c;
          return f === "on" ? [...r, v] : r;
        }, []);
        if (i.length === 1 && i[0] === l)
          return o;
      }
      return o.set(l, a ? "on" : "off"), o;
    },
    in: (n, l, a) => {
      let o = /* @__PURE__ */ new Map();
      for (const i of n || [])
        o = t.select({
          id: i,
          value: !0,
          selected: new Map(o),
          children: l,
          parents: a
        });
      return o;
    },
    out: (n) => {
      const l = [];
      for (const [a, o] of n.entries())
        o === "on" && l.push(a);
      return l;
    }
  };
  return t;
}, Fl = (e) => {
  const t = yn(e);
  return {
    select: (l) => {
      let {
        selected: a,
        id: o,
        ...i
      } = l;
      const r = a.has(o) ? /* @__PURE__ */ new Map([[o, a.get(o)]]) : /* @__PURE__ */ new Map();
      return t.select({
        ...i,
        id: o,
        selected: r
      });
    },
    in: (l, a, o) => {
      let i = /* @__PURE__ */ new Map();
      return l != null && l.length && (i = t.in(l.slice(0, 1), a, o)), i;
    },
    out: (l, a, o) => t.out(l, a, o)
  };
}, Xo = (e) => {
  const t = yn(e);
  return {
    select: (l) => {
      let {
        id: a,
        selected: o,
        children: i,
        ...r
      } = l;
      return i.has(a) ? o : t.select({
        id: a,
        selected: o,
        children: i,
        ...r
      });
    },
    in: t.in,
    out: t.out
  };
}, Zo = (e) => {
  const t = Fl(e);
  return {
    select: (l) => {
      let {
        id: a,
        selected: o,
        children: i,
        ...r
      } = l;
      return i.has(a) ? o : t.select({
        id: a,
        selected: o,
        children: i,
        ...r
      });
    },
    in: t.in,
    out: t.out
  };
}, Jo = (e) => {
  const t = {
    select: (n) => {
      let {
        id: l,
        value: a,
        selected: o,
        children: i,
        parents: r
      } = n;
      const c = new Map(o), v = [l];
      for (; v.length; ) {
        const d = v.shift();
        o.set(d, a ? "on" : "off"), i.has(d) && v.push(...i.get(d));
      }
      let f = r.get(l);
      for (; f; ) {
        const d = i.get(f), u = d.every((p) => o.get(p) === "on"), m = d.every((p) => !o.has(p) || o.get(p) === "off");
        o.set(f, u ? "on" : m ? "off" : "indeterminate"), f = r.get(f);
      }
      return e && !a && Array.from(o.entries()).reduce((u, m) => {
        let [p, g] = m;
        return g === "on" ? [...u, p] : u;
      }, []).length === 0 ? c : o;
    },
    in: (n, l, a) => {
      let o = /* @__PURE__ */ new Map();
      for (const i of n || [])
        o = t.select({
          id: i,
          value: !0,
          selected: new Map(o),
          children: l,
          parents: a
        });
      return o;
    },
    out: (n, l) => {
      const a = [];
      for (const [o, i] of n.entries())
        i === "on" && !l.has(o) && a.push(o);
      return a;
    }
  };
  return t;
}, We = Symbol.for("vuetify:nested"), Tl = {
  id: A(),
  root: {
    register: () => null,
    unregister: () => null,
    parents: A(/* @__PURE__ */ new Map()),
    children: A(/* @__PURE__ */ new Map()),
    open: () => null,
    openOnSelect: () => null,
    select: () => null,
    opened: A(/* @__PURE__ */ new Set()),
    selected: A(/* @__PURE__ */ new Map()),
    selectedValues: A([])
  }
}, Qo = R({
  selectStrategy: [String, Function],
  openStrategy: [String, Object],
  opened: Array,
  selected: Array,
  mandatory: Boolean
}, "nested"), ei = (e) => {
  let t = !1;
  const n = A(/* @__PURE__ */ new Map()), l = A(/* @__PURE__ */ new Map()), a = q(e, "opened", e.opened, (d) => new Set(d), (d) => [...d.values()]), o = y(() => {
    if (typeof e.selectStrategy == "object")
      return e.selectStrategy;
    switch (e.selectStrategy) {
      case "single-leaf":
        return Zo(e.mandatory);
      case "leaf":
        return Xo(e.mandatory);
      case "independent":
        return yn(e.mandatory);
      case "single-independent":
        return Fl(e.mandatory);
      case "classic":
      default:
        return Jo(e.mandatory);
    }
  }), i = y(() => {
    if (typeof e.openStrategy == "object")
      return e.openStrategy;
    switch (e.openStrategy) {
      case "list":
        return Yo;
      case "single":
        return qo;
      case "multiple":
      default:
        return Ll;
    }
  }), r = q(e, "selected", e.selected, (d) => o.value.in(d, n.value, l.value), (d) => o.value.out(d, n.value, l.value));
  _e(() => {
    t = !0;
  });
  function c(d) {
    const u = [];
    let m = d;
    for (; m != null; )
      u.unshift(m), m = l.value.get(m);
    return u;
  }
  const v = te("nested"), f = {
    id: A(),
    root: {
      opened: a,
      selected: r,
      selectedValues: y(() => {
        const d = [];
        for (const [u, m] of r.value.entries())
          m === "on" && d.push(u);
        return d;
      }),
      register: (d, u, m) => {
        u && d !== u && l.value.set(d, u), m && n.value.set(d, []), u != null && n.value.set(u, [...n.value.get(u) || [], d]);
      },
      unregister: (d) => {
        if (t)
          return;
        n.value.delete(d);
        const u = l.value.get(d);
        if (u) {
          const m = n.value.get(u) ?? [];
          n.value.set(u, m.filter((p) => p !== d));
        }
        l.value.delete(d), a.value.delete(d);
      },
      open: (d, u, m) => {
        v.emit("click:open", {
          id: d,
          value: u,
          path: c(d),
          event: m
        });
        const p = i.value.open({
          id: d,
          value: u,
          opened: new Set(a.value),
          children: n.value,
          parents: l.value,
          event: m
        });
        p && (a.value = p);
      },
      openOnSelect: (d, u, m) => {
        const p = i.value.select({
          id: d,
          value: u,
          selected: new Map(r.value),
          opened: new Set(a.value),
          children: n.value,
          parents: l.value,
          event: m
        });
        p && (a.value = p);
      },
      select: (d, u, m) => {
        v.emit("click:select", {
          id: d,
          value: u,
          path: c(d),
          event: m
        });
        const p = o.value.select({
          id: d,
          value: u,
          selected: new Map(r.value),
          children: n.value,
          parents: l.value,
          event: m
        });
        p && (r.value = p), f.root.openOnSelect(d, u, m);
      },
      children: n,
      parents: l
    }
  };
  return re(We, f), f.root;
}, Dl = (e, t) => {
  const n = X(We, Tl), l = y(() => e.value ?? Symbol(ue())), a = {
    ...n,
    id: l,
    open: (o, i) => n.root.open(l.value, o, i),
    openOnSelect: (o, i) => n.root.openOnSelect(l.value, o, i),
    isOpen: y(() => n.root.opened.value.has(l.value)),
    parent: y(() => n.root.parents.value.get(l.value)),
    select: (o, i) => n.root.select(l.value, o, i),
    isSelected: y(() => n.root.selected.value.get(l.value) === "on"),
    isIndeterminate: y(() => n.root.selected.value.get(l.value) === "indeterminate"),
    isLeaf: y(() => !n.root.children.value.get(l.value)),
    isGroupActivator: n.isGroupActivator
  };
  return !n.isGroupActivator && n.root.register(l.value, n.id.value, t), _e(() => {
    !n.isGroupActivator && n.root.unregister(l.value);
  }), t && re(We, a), a;
}, ti = () => {
  const e = X(We, Tl);
  re(We, {
    ...e,
    isGroupActivator: !0
  });
}, ni = G({
  name: "VListGroupActivator",
  setup(e, t) {
    let {
      slots: n
    } = t;
    return ti(), () => {
      var l;
      return (l = n.default) == null ? void 0 : l.call(n);
    };
  }
}), li = R({
  activeColor: String,
  color: String,
  collapseIcon: {
    type: K,
    default: "$collapse"
  },
  expandIcon: {
    type: K,
    default: "$expand"
  },
  prependIcon: K,
  appendIcon: K,
  fluid: Boolean,
  subgroup: Boolean,
  value: null,
  ...ye()
}, "v-list-group"), Rl = ne()({
  name: "VListGroup",
  props: {
    title: String,
    ...li()
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      isOpen: l,
      open: a,
      id: o
    } = Dl(j(e, "value"), !0), i = y(() => `v-list-group--id-${String(o.value)}`), r = Bl();
    function c(d) {
      a(!l.value, d);
    }
    const v = y(() => ({
      onClick: c,
      class: "v-list-group__header",
      id: i.value
    })), f = y(() => l.value ? e.collapseIcon : e.expandIcon);
    return W(() => {
      var d;
      return s(e.tag, {
        class: ["v-list-group", {
          "v-list-group--prepend": r == null ? void 0 : r.hasPrepend.value,
          "v-list-group--fluid": e.fluid,
          "v-list-group--subgroup": e.subgroup,
          "v-list-group--open": l.value
        }]
      }, {
        default: () => [n.activator && s(ie, {
          defaults: {
            VListItem: {
              active: l.value,
              activeColor: e.activeColor,
              color: e.color,
              prependIcon: e.prependIcon || e.subgroup && f.value,
              appendIcon: e.appendIcon || !e.subgroup && f.value,
              title: e.title,
              value: e.value
            }
          }
        }, {
          default: () => [s(ni, null, {
            default: () => [n.activator({
              props: v.value,
              isOpen: l
            })]
          })]
        }), s(Ca, null, {
          default: () => [Q(s("div", {
            class: "v-list-group__items",
            role: "group",
            "aria-labelledby": i.value
          }, [(d = n.default) == null ? void 0 : d.call(n)]), [[Oe, l.value]])]
        })]
      });
    }), {};
  }
});
function ai(e) {
  return fe(e, Object.keys(Rl.props));
}
const oi = Jn("v-list-item-subtitle"), ii = Jn("v-list-item-title"), Ie = ne()({
  name: "VListItem",
  directives: {
    Ripple: on
  },
  props: {
    active: {
      type: Boolean,
      default: void 0
    },
    activeClass: String,
    activeColor: String,
    appendAvatar: String,
    appendIcon: K,
    disabled: Boolean,
    lines: String,
    link: {
      type: Boolean,
      default: void 0
    },
    nav: Boolean,
    prependAvatar: String,
    prependIcon: K,
    subtitle: [String, Number, Boolean],
    title: [String, Number, Boolean],
    value: null,
    onClick: Se,
    onClickOnce: Se,
    ...vn(),
    ...Te(),
    ...pt(),
    ...mn(),
    ...Be(),
    ...xl(),
    ...ye(),
    ...ae(),
    ...Ne({
      variant: "text"
    })
  },
  emits: {
    click: (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: l,
      emit: a
    } = t;
    const o = kl(e, n), i = y(() => e.value ?? o.href.value), {
      select: r,
      isSelected: c,
      isIndeterminate: v,
      isGroupActivator: f,
      root: d,
      parent: u,
      openOnSelect: m
    } = Dl(i, !1), p = Bl(), g = y(() => {
      var T;
      return e.active !== !1 && (e.active || ((T = o.isActive) == null ? void 0 : T.value) || c.value);
    }), b = y(() => e.link !== !1 && o.isLink.value), w = y(() => !e.disabled && e.link !== !1 && (e.link || o.isClickable.value || e.value != null && !!p)), V = y(() => e.rounded || e.nav), h = y(() => ({
      color: g.value ? e.activeColor ?? e.color : e.color,
      variant: e.variant
    }));
    H(() => {
      var T;
      return (T = o.isActive) == null ? void 0 : T.value;
    }, (T) => {
      T && u.value != null && d.open(u.value, !0), T && m(T);
    }, {
      immediate: !0
    });
    const {
      themeClasses: I
    } = ce(e), {
      borderClasses: x
    } = fn(e), {
      colorClasses: B,
      colorStyles: P,
      variantClasses: S
    } = Ct(h), {
      densityClasses: _
    } = De(e), {
      dimensionStyles: C
    } = bt(e), {
      elevationClasses: k
    } = gn(e), {
      roundedClasses: $
    } = Le(V), O = y(() => e.lines ? `v-list-item--${e.lines}-line` : void 0), E = y(() => ({
      isActive: g.value,
      select: r,
      isSelected: c.value,
      isIndeterminate: v.value
    }));
    function L(T) {
      var F;
      a("click", T), !(f || !w.value) && ((F = o.navigate) == null || F.call(o, T), e.value != null && r(!c.value, T));
    }
    function N(T) {
      (T.key === "Enter" || T.key === " ") && (T.preventDefault(), L(T));
    }
    return W(() => {
      var T, F, D, U, Y;
      const he = b.value ? "a" : e.tag, Qe = !p || c.value || g.value, _t = l.title || e.title, ql = l.subtitle || e.subtitle, Yl = !!(l.append || e.appendAvatar || e.appendIcon), wt = !!(l.prepend || e.prependAvatar || e.prependIcon);
      return p == null || p.updateHasPrepend(wt), Q(s(he, {
        class: ["v-list-item", {
          "v-list-item--active": g.value,
          "v-list-item--disabled": e.disabled,
          "v-list-item--link": w.value,
          "v-list-item--nav": e.nav,
          "v-list-item--prepend": !wt && (p == null ? void 0 : p.hasPrepend.value),
          [`${e.activeClass}`]: e.activeClass && g.value
        }, I.value, x.value, Qe ? B.value : void 0, _.value, k.value, O.value, $.value, S.value],
        style: [Qe ? P.value : void 0, C.value],
        href: o.href.value,
        tabindex: w.value ? 0 : void 0,
        onClick: L,
        onKeydown: w.value && !b.value && N
      }, {
        default: () => [St(w.value || g.value, "v-list-item"), wt && s(ie, {
          key: "prepend",
          defaults: {
            VAvatar: {
              density: e.density,
              image: e.prependAvatar
            },
            VIcon: {
              density: e.density,
              icon: e.prependIcon
            },
            VListItemAction: {
              start: !0
            }
          }
        }, {
          default: () => [s("div", {
            class: "v-list-item__prepend"
          }, [e.prependAvatar && s(ut, {
            key: "prepend-avatar"
          }, null), e.prependIcon && s(me, {
            key: "prepend-icon"
          }, null), (T = l.prepend) == null ? void 0 : T.call(l, E.value)])]
        }), s("div", {
          class: "v-list-item__content",
          "data-no-activator": ""
        }, [_t && s(ii, {
          key: "title"
        }, {
          default: () => [((F = l.title) == null ? void 0 : F.call(l, {
            title: e.title
          })) ?? e.title]
        }), ql && s(oi, {
          key: "subtitle"
        }, {
          default: () => [((D = l.subtitle) == null ? void 0 : D.call(l, {
            subtitle: e.subtitle
          })) ?? e.subtitle]
        }), (U = l.default) == null ? void 0 : U.call(l, E.value)]), Yl && s(ie, {
          key: "append",
          defaults: {
            VAvatar: {
              density: e.density,
              image: e.appendAvatar
            },
            VIcon: {
              density: e.density,
              icon: e.appendIcon
            },
            VListItemAction: {
              end: !0
            }
          }
        }, {
          default: () => [s("div", {
            class: "v-list-item__append"
          }, [(Y = l.append) == null ? void 0 : Y.call(l, E.value), e.appendIcon && s(me, {
            key: "append-icon"
          }, null), e.appendAvatar && s(ut, {
            key: "append-avatar"
          }, null)])]
        })]
      }), [[we("ripple"), w.value]]);
    }), {};
  }
}), ri = G({
  name: "VListSubheader",
  props: {
    color: String,
    inset: Boolean,
    sticky: Boolean,
    title: String,
    ...ye()
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      textColorClasses: l,
      textColorStyles: a
    } = Ee(j(e, "color"));
    return W(() => {
      var o;
      const i = !!(n.default || e.title);
      return s(e.tag, {
        class: ["v-list-subheader", {
          "v-list-subheader--inset": e.inset,
          "v-list-subheader--sticky": e.sticky
        }, l.value],
        style: {
          textColorStyles: a
        }
      }, {
        default: () => [i && s("div", {
          class: "v-list-subheader__text"
        }, [((o = n.default) == null ? void 0 : o.call(n)) ?? e.title])]
      });
    }), {};
  }
}), Nl = ne()({
  name: "VListChildren",
  props: {
    items: Array
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    return El(), () => {
      var l, a;
      return ((l = n.default) == null ? void 0 : l.call(n)) ?? ((a = e.items) == null ? void 0 : a.map((o) => {
        let {
          children: i,
          props: r,
          type: c,
          raw: v
        } = o;
        if (c === "divider") {
          var f;
          return ((f = n.divider) == null ? void 0 : f.call(n, {
            props: r
          })) ?? s(Ko, r, null);
        }
        if (c === "subheader") {
          var d;
          return ((d = n.subheader) == null ? void 0 : d.call(n, {
            props: r
          })) ?? s(ri, r, {
            default: n.subheader
          });
        }
        const u = {
          subtitle: n.subtitle ? (g) => {
            var b;
            return (b = n.subtitle) == null ? void 0 : b.call(n, {
              ...g,
              item: v
            });
          } : void 0,
          prepend: n.prepend ? (g) => {
            var b;
            return (b = n.prepend) == null ? void 0 : b.call(n, {
              ...g,
              item: v
            });
          } : void 0,
          append: n.append ? (g) => {
            var b;
            return (b = n.append) == null ? void 0 : b.call(n, {
              ...g,
              item: v
            });
          } : void 0,
          default: n.default ? (g) => {
            var b;
            return (b = n.default) == null ? void 0 : b.call(n, {
              ...g,
              item: v
            });
          } : void 0,
          title: n.title ? (g) => {
            var b;
            return (b = n.title) == null ? void 0 : b.call(n, {
              ...g,
              item: v
            });
          } : void 0
        }, [m, p] = ai(r);
        return i ? s(Rl, M({
          value: r == null ? void 0 : r.value
        }, m), {
          activator: (g) => {
            let {
              props: b
            } = g;
            return n.header ? n.header({
              ...r,
              ...b
            }) : s(Ie, M(r, b), u);
          },
          default: () => s(Nl, {
            items: i
          }, n)
        }) : n.item ? n.item(r) : s(Ie, r, u);
      }));
    };
  }
}), Ml = R({
  items: {
    type: Array,
    default: () => []
  },
  itemTitle: {
    type: [String, Array, Function],
    default: "title"
  },
  itemValue: {
    type: [String, Array, Function],
    default: "value"
  },
  itemChildren: {
    type: [Boolean, String, Array, Function],
    default: "children"
  },
  itemProps: {
    type: [Boolean, String, Array, Function],
    default: "props"
  },
  returnObject: Boolean
}, "item");
function zl(e, t) {
  const n = de(t, e.itemTitle, t), l = e.returnObject ? t : de(t, e.itemValue, n), a = de(t, e.itemChildren), o = e.itemProps === !0 ? typeof t == "object" && t != null && !Array.isArray(t) ? "children" in t ? fe(t, ["children"])[1] : t : void 0 : de(t, e.itemProps), i = {
    title: n,
    value: l,
    ...o
  };
  return {
    title: String(i.title ?? ""),
    value: i.value,
    props: i,
    children: Array.isArray(a) ? Hl(e, a) : void 0,
    raw: t
  };
}
function Hl(e, t) {
  const n = [];
  for (const l of t)
    n.push(zl(e, l));
  return n;
}
function jl(e) {
  const t = y(() => Hl(e, e.items));
  function n(a) {
    return a.map((o) => zl(e, o));
  }
  function l(a) {
    return a.map((o) => {
      let {
        props: i
      } = o;
      return i.value;
    });
  }
  return {
    items: t,
    transformIn: n,
    transformOut: l
  };
}
function si(e, t) {
  const n = de(t, e.itemType, "item"), l = typeof t == "string" ? t : de(t, e.itemTitle), a = de(t, e.itemValue, void 0), o = de(t, e.itemChildren), i = e.itemProps === !0 ? fe(t, ["children"])[1] : de(t, e.itemProps), r = {
    title: l,
    value: a,
    ...i
  };
  return {
    type: n,
    title: r.title,
    value: r.value,
    props: r,
    children: n === "item" && o ? Wl(e, o) : void 0,
    raw: t
  };
}
function Wl(e, t) {
  const n = [];
  for (const l of t)
    n.push(si(e, l));
  return n;
}
function ui(e) {
  return {
    items: y(() => Wl(e, e.items))
  };
}
const Gl = ne()({
  name: "VList",
  props: {
    activeColor: String,
    activeClass: String,
    bgColor: String,
    disabled: Boolean,
    lines: {
      type: [Boolean, String],
      default: "one"
    },
    nav: Boolean,
    ...Qo({
      selectStrategy: "single-leaf",
      openStrategy: "list"
    }),
    ...vn(),
    ...Te(),
    ...pt(),
    ...mn(),
    itemType: {
      type: String,
      default: "type"
    },
    ...Ml(),
    ...Be(),
    ...ye(),
    ...ae(),
    ...Ne({
      variant: "text"
    })
  },
  emits: {
    "update:selected": (e) => !0,
    "update:opened": (e) => !0,
    "click:open": (e) => !0,
    "click:select": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      items: l
    } = ui(e), {
      themeClasses: a
    } = ce(e), {
      backgroundColorClasses: o,
      backgroundColorStyles: i
    } = $e(j(e, "bgColor")), {
      borderClasses: r
    } = fn(e), {
      densityClasses: c
    } = De(e), {
      dimensionStyles: v
    } = bt(e), {
      elevationClasses: f
    } = gn(e), {
      roundedClasses: d
    } = Le(e), {
      open: u,
      select: m
    } = ei(e), p = y(() => e.lines ? `v-list--${e.lines}-line` : void 0), g = j(e, "activeColor"), b = j(e, "color");
    El(), Xe({
      VListGroup: {
        activeColor: g,
        color: b
      },
      VListItem: {
        activeClass: j(e, "activeClass"),
        activeColor: g,
        color: b,
        density: j(e, "density"),
        disabled: j(e, "disabled"),
        lines: j(e, "lines"),
        nav: j(e, "nav"),
        variant: j(e, "variant")
      }
    });
    const w = A(!1), V = A();
    function h(S) {
      w.value = !0;
    }
    function I(S) {
      w.value = !1;
    }
    function x(S) {
      var _;
      !w.value && !(S.relatedTarget && (_ = V.value) != null && _.contains(S.relatedTarget)) && P();
    }
    function B(S) {
      if (V.value) {
        if (S.key === "ArrowDown")
          P("next");
        else if (S.key === "ArrowUp")
          P("prev");
        else if (S.key === "Home")
          P("first");
        else if (S.key === "End")
          P("last");
        else
          return;
        S.preventDefault();
      }
    }
    function P(S) {
      if (!V.value)
        return;
      const _ = [...V.value.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')].filter((E) => !E.hasAttribute("disabled")), C = _.indexOf(document.activeElement);
      if (S)
        if (S === "first") {
          var $;
          ($ = _[0]) == null || $.focus();
        } else if (S === "last") {
          var O;
          (O = _.at(-1)) == null || O.focus();
        } else {
          let E, L = C;
          const N = S === "next" ? 1 : -1;
          do
            L += N, E = _[L];
          while ((!E || E.offsetParent == null) && L < _.length && L >= 0);
          E ? E.focus() : P(S === "next" ? "first" : "last");
        }
      else if (!V.value.contains(document.activeElement)) {
        var k;
        (k = _[0]) == null || k.focus();
      }
    }
    return W(() => s(e.tag, {
      ref: V,
      class: ["v-list", {
        "v-list--disabled": e.disabled,
        "v-list--nav": e.nav
      }, a.value, o.value, r.value, c.value, f.value, p.value, d.value],
      style: [i.value, v.value],
      role: "listbox",
      "aria-activedescendant": void 0,
      onFocusin: h,
      onFocusout: I,
      onFocus: x,
      onKeydown: B
    }, {
      default: () => [s(Nl, {
        items: l.value
      }, n)]
    })), {
      open: u,
      select: m,
      focus: P
    };
  }
});
const Ul = ne()({
  name: "VMenu",
  props: {
    // TODO
    // disableKeys: Boolean,
    id: String,
    ...qe(cn({
      closeDelay: 250,
      closeOnContentClick: !0,
      locationStrategy: "connected",
      openDelay: 300,
      scrim: !1,
      scrollStrategy: "reposition",
      transition: {
        component: nl
      }
    }), ["absolute"])
  },
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const l = q(e, "modelValue"), {
      scopeId: a
    } = un(), o = ue(), i = y(() => e.id || `v-menu-${o}`), r = A(), c = X(Rt, null);
    let v = 0;
    re(Rt, {
      register() {
        ++v;
      },
      unregister() {
        --v;
      },
      closeParents() {
        setTimeout(() => {
          v || (l.value = !1, c == null || c.closeParents());
        }, 40);
      }
    }), H(l, (d) => {
      d ? c == null || c.register() : c == null || c.unregister();
    });
    function f() {
      c == null || c.closeParents();
    }
    return W(() => {
      const [d] = Il(e);
      return s(dn, M({
        ref: r,
        class: ["v-menu"]
      }, d, {
        modelValue: l.value,
        "onUpdate:modelValue": (u) => l.value = u,
        absolute: !0,
        activatorProps: M({
          "aria-haspopup": "menu",
          "aria-expanded": String(l.value),
          "aria-owns": i.value
        }, e.activatorProps),
        "onClick:outside": f
      }, a), {
        activator: n.activator,
        default: function() {
          for (var u, m = arguments.length, p = new Array(m), g = 0; g < m; g++)
            p[g] = arguments[g];
          return s(ie, {
            root: !0
          }, {
            default: () => [(u = n.default) == null ? void 0 : u.call(n, ...p)]
          });
        }
      });
    }), Re({
      id: i
    }, r);
  }
}), Kl = R({
  chips: Boolean,
  closableChips: Boolean,
  eager: Boolean,
  hideNoData: Boolean,
  hideSelected: Boolean,
  menu: Boolean,
  menuIcon: {
    type: K,
    default: "$dropdown"
  },
  menuProps: {
    type: Object
  },
  multiple: Boolean,
  noDataText: {
    type: String,
    default: "$vuetify.noDataText"
  },
  openOnClear: Boolean,
  valueComparator: {
    type: Function,
    default: Ke
  },
  ...Ml({
    itemChildren: !1
  })
}, "v-select"), ci = ne()({
  name: "VSelect",
  props: {
    ...Kl(),
    ...qe(ln({
      modelValue: null
    }), ["validationValue", "dirty", "appendInnerIcon"]),
    ...Fe({
      transition: {
        component: nl
      }
    })
  },
  emits: {
    "update:modelValue": (e) => !0,
    "update:menu": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      t: l
    } = Zt(), a = A(), o = q(e, "menu"), {
      items: i,
      transformIn: r,
      transformOut: c
    } = jl(e), v = q(e, "modelValue", [], (h) => r(ve(h)), (h) => {
      const I = c(h);
      return e.multiple ? I : I[0] ?? null;
    }), f = y(() => v.value.map((h) => i.value.find((I) => e.valueComparator(I.value, h.value)) || h)), d = y(() => f.value.map((h) => h.props.value)), u = A();
    function m(h) {
      v.value = [], e.openOnClear && (o.value = !0);
    }
    function p() {
      e.hideNoData && !i.value.length || e.readonly || (o.value = !o.value);
    }
    function g(h) {
      if (!e.readonly) {
        if (["Enter", "ArrowDown", " "].includes(h.key) && (h.preventDefault(), o.value = !0), ["Escape", "Tab"].includes(h.key) && (o.value = !1), h.key === "ArrowDown") {
          var I;
          (I = u.value) == null || I.focus("next");
        } else if (h.key === "ArrowUp") {
          var x;
          h.preventDefault(), (x = u.value) == null || x.focus("prev");
        } else if (h.key === "Home") {
          var B;
          h.preventDefault(), (B = u.value) == null || B.focus("first");
        } else if (h.key === "End") {
          var P;
          h.preventDefault(), (P = u.value) == null || P.focus("last");
        }
      }
    }
    function b(h) {
      if (e.multiple) {
        const I = d.value.findIndex((x) => x === h.value);
        if (I === -1)
          v.value = [...v.value, h];
        else {
          const x = [...v.value];
          x.splice(I, 1), v.value = x;
        }
      } else
        v.value = [h], o.value = !1;
    }
    function w(h) {
      var I;
      (I = u.value) != null && I.$el.contains(h.relatedTarget) || (o.value = !1);
    }
    function V(h) {
      if (h.relatedTarget == null) {
        var I;
        (I = a.value) == null || I.focus();
      }
    }
    return W(() => {
      const h = !!(e.chips || n.chip), [I] = dl(e);
      return s(yt, M({
        ref: a
      }, I, {
        modelValue: v.value.map((x) => x.props.value).join(", "),
        "onUpdate:modelValue": (x) => {
          x == null && (v.value = []);
        },
        validationValue: v.externalValue,
        dirty: v.value.length > 0,
        class: ["v-select", {
          "v-select--active-menu": o.value,
          "v-select--chips": !!e.chips,
          [`v-select--${e.multiple ? "multiple" : "single"}`]: !0,
          "v-select--selected": v.value.length
        }],
        appendInnerIcon: e.menuIcon,
        readonly: !0,
        "onClick:clear": m,
        "onClick:control": p,
        onBlur: w,
        onKeydown: g
      }), {
        ...n,
        default: () => {
          var x, B, P;
          return s(Z, null, [s(Ul, M({
            modelValue: o.value,
            "onUpdate:modelValue": (S) => o.value = S,
            activator: "parent",
            contentClass: "v-select__content",
            eager: e.eager,
            openOnClick: !1,
            closeOnContentClick: !1,
            transition: e.transition
          }, e.menuProps), {
            default: () => [s(Gl, {
              ref: u,
              selected: d.value,
              selectStrategy: e.multiple ? "independent" : "single-independent",
              onMousedown: (S) => S.preventDefault(),
              onFocusout: V
            }, {
              default: () => [!i.value.length && !e.hideNoData && (((x = n["no-data"]) == null ? void 0 : x.call(n)) ?? s(Ie, {
                title: l(e.noDataText)
              }, null)), (B = n["prepend-item"]) == null ? void 0 : B.call(n), i.value.map((S, _) => {
                var C;
                return ((C = n.item) == null ? void 0 : C.call(n, {
                  item: S,
                  index: _,
                  props: M(S.props, {
                    onClick: () => b(S)
                  })
                })) ?? s(Ie, M({
                  key: _
                }, S.props, {
                  onClick: () => b(S)
                }), {
                  prepend: (k) => {
                    let {
                      isSelected: $
                    } = k;
                    return e.multiple && !e.hideSelected ? s(ht, {
                      modelValue: $,
                      ripple: !1
                    }, null) : void 0;
                  }
                });
              }), (P = n["append-item"]) == null ? void 0 : P.call(n)]
            })]
          }), f.value.map((S, _) => {
            function C($) {
              $.stopPropagation(), $.preventDefault(), b(S);
            }
            const k = {
              "onClick:close": C,
              modelValue: !0,
              "onUpdate:modelValue": void 0
            };
            return s("div", {
              key: S.value,
              class: "v-select__selection"
            }, [h ? s(ie, {
              defaults: {
                VChip: {
                  closable: e.closableChips,
                  size: "small",
                  text: S.title
                }
              }
            }, {
              default: () => [n.chip ? n.chip({
                item: S,
                index: _,
                props: k
              }) : s(Ol, k, null)]
            }) : n.selection ? n.selection({
              item: S,
              index: _
            }) : s("span", {
              class: "v-select__selection-text"
            }, [S.title, e.multiple && _ < f.value.length - 1 && s("span", {
              class: "v-select__selection-comma"
            }, [Hn(",")])])]);
          })]);
        }
      });
    }), Re({
      menu: o,
      select: b
    }, a);
  }
}), di = (e, t, n) => e == null || t == null ? -1 : e.toString().toLocaleLowerCase().indexOf(t.toString().toLocaleLowerCase()), vi = R({
  customFilter: Function,
  customKeyFilter: Object,
  filterKeys: [Array, String],
  filterMode: {
    type: String,
    default: "intersection"
  },
  noFilter: Boolean
}, "filter");
function fi(e, t, n) {
  const l = [], a = (n == null ? void 0 : n.default) ?? di, o = n != null && n.filterKeys ? ve(n.filterKeys) : !1, i = Object.keys((n == null ? void 0 : n.customKeyFilter) ?? {}).length;
  if (!(e != null && e.length))
    return l;
  e:
    for (let c = 0; c < e.length; c++) {
      const v = e[c], f = {}, d = {};
      let u = -1;
      if (t && !(n != null && n.noFilter)) {
        if (typeof v == "object") {
          const g = o || Object.keys(v);
          for (const b of g) {
            var r;
            const w = de(v, b, v), V = n == null || (r = n.customKeyFilter) == null ? void 0 : r[b];
            if (u = V ? V(w, t, v) : a(w, t, v), u !== -1 && u !== !1)
              V ? f[b] = u : d[b] = u;
            else if ((n == null ? void 0 : n.filterMode) === "every")
              continue e;
          }
        } else
          u = a(v, t, v), u !== -1 && u !== !1 && (d.title = u);
        const m = Object.keys(d).length, p = Object.keys(f).length;
        if (!m && !p || (n == null ? void 0 : n.filterMode) === "union" && p !== i && !m || (n == null ? void 0 : n.filterMode) === "intersection" && (p !== i || !m))
          continue;
      }
      l.push({
        index: c,
        matches: {
          ...d,
          ...f
        }
      });
    }
  return l;
}
function mi(e, t, n) {
  const l = y(() => typeof (n == null ? void 0 : n.value) != "string" && typeof (n == null ? void 0 : n.value) != "number" ? "" : String(n.value));
  return {
    filteredItems: y(() => {
      const o = be(t);
      return fi(o, l.value, {
        customKeyFilter: e.customKeyFilter,
        default: e.customFilter,
        filterKeys: e.filterKeys,
        filterMode: e.filterMode,
        noFilter: e.noFilter
      }).map((r) => {
        let {
          index: c,
          matches: v
        } = r;
        return {
          item: o[c],
          matches: v
        };
      });
    })
  };
}
function gi(e, t, n) {
  if (Array.isArray(t))
    throw new Error("Multiple matches is not implemented");
  return typeof t == "number" && ~t ? s(Z, null, [s("span", {
    class: "v-autocomplete__unmask"
  }, [e.substr(0, t)]), s("span", {
    class: "v-autocomplete__mask"
  }, [e.substr(t, n)]), s("span", {
    class: "v-autocomplete__unmask"
  }, [e.substr(t + n)])]) : e;
}
const yi = ne()({
  name: "VAutocomplete",
  props: {
    // TODO: implement post keyboard support
    // autoSelectFirst: Boolean,
    search: String,
    ...vi({
      filterKeys: ["title"]
    }),
    ...Kl(),
    ...qe(ln({
      modelValue: null
    }), ["validationValue", "dirty", "appendInnerIcon"]),
    ...Fe({
      transition: !1
    })
  },
  emits: {
    "update:search": (e) => !0,
    "update:modelValue": (e) => !0,
    "update:menu": (e) => !0
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    const {
      t: l
    } = Zt(), a = A(), o = A(!1), i = A(!0), r = q(e, "menu"), {
      items: c,
      transformIn: v,
      transformOut: f
    } = jl(e), d = q(e, "search", ""), u = q(e, "modelValue", [], (C) => v(ve(C)), (C) => {
      const k = f(C);
      return e.multiple ? k : k[0] ?? null;
    }), {
      filteredItems: m
    } = mi(e, c, y(() => i.value ? void 0 : d.value)), p = y(() => u.value.map((C) => c.value.find((k) => e.valueComparator(k.value, C.value)) || C)), g = y(() => p.value.map((C) => C.props.value)), b = A();
    function w(C) {
      u.value = [], e.openOnClear && (r.value = !0), d.value = "";
    }
    function V() {
      e.hideNoData && !c.value.length || e.readonly || (r.value = !0);
    }
    function h(C) {
      if (!e.readonly) {
        if (["Enter", "ArrowDown"].includes(C.key) && (r.value = !0), ["Escape"].includes(C.key) && (r.value = !1), ["Enter", "Escape", "Tab"].includes(C.key) && (i.value = !0), C.key === "ArrowDown") {
          var k;
          C.preventDefault(), (k = b.value) == null || k.focus("next");
        } else if (C.key === "ArrowUp") {
          var $;
          C.preventDefault(), ($ = b.value) == null || $.focus("prev");
        }
      }
    }
    function I(C) {
      d.value = C.target.value;
    }
    function x() {
      o.value && (i.value = !0);
    }
    function B(C) {
      o.value = !0;
    }
    function P(C) {
      if (C.relatedTarget == null) {
        var k;
        (k = a.value) == null || k.focus();
      }
    }
    const S = A(!1);
    function _(C) {
      if (e.multiple) {
        const k = g.value.findIndex(($) => $ === C.value);
        if (k === -1)
          u.value = [...u.value, C], d.value = "";
        else {
          const $ = [...u.value];
          $.splice(k, 1), u.value = $;
        }
      } else
        u.value = [C], S.value = !0, n.selection || (d.value = C.title), r.value = !1, i.value = !0, ee(() => S.value = !1);
    }
    return H(o, (C) => {
      if (C) {
        var k;
        S.value = !0, d.value = e.multiple || n.selection ? "" : String(((k = p.value.at(-1)) == null ? void 0 : k.props.title) ?? ""), i.value = !0, ee(() => S.value = !1);
      } else
        r.value = !1, d.value = "";
    }), H(d, (C) => {
      !o.value || S.value || (C && (r.value = !0), i.value = !C);
    }), W(() => {
      const C = !!(e.chips || n.chip), [k] = dl(e);
      return s(yt, M({
        ref: a
      }, k, {
        modelValue: d.value,
        "onUpdate:modelValue": ($) => {
          $ == null && (u.value = []);
        },
        validationValue: u.externalValue,
        dirty: u.value.length > 0,
        onInput: I,
        class: ["v-autocomplete", {
          "v-autocomplete--active-menu": r.value,
          "v-autocomplete--chips": !!e.chips,
          [`v-autocomplete--${e.multiple ? "multiple" : "single"}`]: !0,
          "v-autocomplete--selection-slot": !!n.selection
        }],
        appendInnerIcon: e.menuIcon,
        readonly: e.readonly,
        "onClick:clear": w,
        "onClick:control": V,
        "onClick:input": V,
        onFocus: () => o.value = !0,
        onBlur: () => o.value = !1,
        onKeydown: h
      }), {
        ...n,
        default: () => {
          var $, O, E;
          return s(Z, null, [s(Ul, M({
            modelValue: r.value,
            "onUpdate:modelValue": (L) => r.value = L,
            activator: "parent",
            contentClass: "v-autocomplete__content",
            eager: e.eager,
            openOnClick: !1,
            closeOnContentClick: !1,
            transition: e.transition,
            onAfterLeave: x
          }, e.menuProps), {
            default: () => [s(Gl, {
              ref: b,
              selected: g.value,
              selectStrategy: e.multiple ? "independent" : "single-independent",
              onMousedown: (L) => L.preventDefault(),
              onFocusin: B,
              onFocusout: P
            }, {
              default: () => [!m.value.length && !e.hideNoData && ((($ = n["no-data"]) == null ? void 0 : $.call(n)) ?? s(Ie, {
                title: l(e.noDataText)
              }, null)), (O = n["prepend-item"]) == null ? void 0 : O.call(n), m.value.map((L, N) => {
                var T;
                let {
                  item: F,
                  matches: D
                } = L;
                return ((T = n.item) == null ? void 0 : T.call(n, {
                  item: F,
                  index: N,
                  props: M(F.props, {
                    onClick: () => _(F)
                  })
                })) ?? s(Ie, M({
                  key: N
                }, F.props, {
                  onClick: () => _(F)
                }), {
                  prepend: (U) => {
                    let {
                      isSelected: Y
                    } = U;
                    return e.multiple && !e.hideSelected ? s(ht, {
                      modelValue: Y,
                      ripple: !1
                    }, null) : void 0;
                  },
                  title: () => {
                    var U;
                    return i.value ? F.title : gi(F.title, D.title, ((U = d.value) == null ? void 0 : U.length) ?? 0);
                  }
                });
              }), (E = n["append-item"]) == null ? void 0 : E.call(n)]
            })]
          }), p.value.map((L, N) => {
            function T(D) {
              D.stopPropagation(), D.preventDefault(), _(L);
            }
            const F = {
              "onClick:close": T,
              modelValue: !0,
              "onUpdate:modelValue": void 0
            };
            return s("div", {
              key: L.value,
              class: "v-autocomplete__selection"
            }, [C ? s(ie, {
              defaults: {
                VChip: {
                  closable: e.closableChips,
                  size: "small",
                  text: L.title
                }
              }
            }, {
              default: () => [n.chip ? n.chip({
                item: L,
                index: N,
                props: F
              }) : s(Ol, F, null)]
            }) : n.selection ? n.selection({
              item: L,
              index: N
            }) : s("span", {
              class: "v-autocomplete__selection-text"
            }, [L.title, e.multiple && N < p.value.length - 1 && s("span", {
              class: "v-autocomplete__selection-comma"
            }, [Hn(",")])])]);
          })]);
        }
      });
    }), Re({
      isFocused: o,
      isPristine: i,
      menu: r,
      search: d,
      filteredItems: m,
      select: _
    }, a);
  }
}), hi = G({
  name: "VRadio",
  props: {
    ...rn({
      falseIcon: "$radioOff",
      trueIcon: "$radioOn"
    })
  },
  setup(e, t) {
    let {
      slots: n
    } = t;
    return W(() => s(sn, M(e, {
      class: "v-radio",
      type: "radio"
    }), n)), {};
  }
});
const pi = G({
  name: "VRadioGroup",
  inheritAttrs: !1,
  props: {
    height: {
      type: [Number, String],
      default: "auto"
    },
    ...Ze(),
    ...qe(an(), ["multiple"]),
    trueIcon: {
      type: K,
      default: "$radioOn"
    },
    falseIcon: {
      type: K,
      default: "$radioOff"
    },
    type: {
      type: String,
      default: "radio"
    }
  },
  emits: {
    "update:modelValue": (e) => !0
  },
  setup(e, t) {
    let {
      attrs: n,
      slots: l
    } = t;
    const a = ue(), o = y(() => e.id || `radio-group-${a}`), i = q(e, "modelValue");
    return W(() => {
      const [r, c] = Ye(n), [v, f] = gt(e), [d, u] = Xa({
        ...e,
        multiple: !1
      }), m = l.label ? l.label({
        label: e.label,
        props: {
          for: o.value
        }
      }) : e.label;
      return s(Je, M({
        class: "v-radio-group"
      }, r, v, {
        modelValue: i.value,
        "onUpdate:modelValue": (p) => i.value = p,
        id: o.value
      }), {
        ...l,
        default: (p) => {
          let {
            id: g,
            isDisabled: b,
            isReadonly: w
          } = p;
          return s(Z, null, [m && s(Qt, {
            id: g.value
          }, {
            default: () => [m]
          }), s(ja, M(d, {
            id: g.value,
            defaultsTarget: "VRadio",
            trueIcon: e.trueIcon,
            falseIcon: e.falseIcon,
            type: e.type,
            disabled: b.value,
            readonly: w.value,
            "aria-labelledby": m ? g.value : void 0
          }, c, {
            modelValue: i.value,
            "onUpdate:modelValue": (V) => i.value = V
          }), l)]);
        }
      });
    }), {};
  }
}), bi = {
  collapse: "keyboard_arrow_up",
  complete: "check",
  cancel: "cancel",
  close: "close",
  delete: "cancel",
  // delete (e.g. v-chip close)
  clear: "cancel",
  success: "check_circle",
  info: "info",
  warning: "priority_high",
  error: "warning",
  prev: "chevron_left",
  next: "chevron_right",
  checkboxOn: "check_box",
  checkboxOff: "check_box_outline_blank",
  checkboxIndeterminate: "indeterminate_check_box",
  delimiter: "fiber_manual_record",
  // for carousel
  sort: "arrow_upward",
  expand: "keyboard_arrow_down",
  menu: "menu",
  subgroup: "arrow_drop_down",
  dropdown: "arrow_drop_down",
  radioOn: "radio_button_checked",
  radioOff: "radio_button_unchecked",
  edit: "edit",
  ratingEmpty: "star_border",
  ratingFull: "star",
  ratingHalf: "star_half",
  loading: "cached",
  first: "first_page",
  last: "last_page",
  unfold: "unfold_more",
  file: "attach_file",
  plus: "add",
  minus: "remove"
}, Si = {
  // Not using mergeProps here, functional components merge props by default (?)
  component: (e) => Ge(ka, {
    ...e,
    class: "material-icons"
  })
};
const Ci = {
  dark: !1,
  colors: {
    background: "#FFFFFF",
    surface: "#FFFFFF",
    primary: "#0068AD",
    "primary-darken-1": "#0068AD",
    secondary: "#0068AD",
    "secondary-darken-1": "#0068AD",
    error: "#D65432",
    info: "#0068AD",
    success: "#84BD00",
    warning: "#FFC107"
  }
}, xi = Xl({
  components: {
    VTextField: yt,
    VCheckbox: Ja,
    VSnackbar: Fo,
    VTextarea: To,
    VAutocomplete: yi,
    VSelect: ci,
    VRadio: hi,
    VRadioGroup: pi
  },
  directives: {},
  theme: {
    defaultTheme: "customTheme",
    themes: {
      customTheme: Ci
    }
  },
  icons: {
    defaultSet: "md",
    aliases: bi,
    sets: {
      md: Si
    }
  }
});
export {
  To as V,
  ci as a,
  yi as b,
  Fo as c,
  yt as d,
  xi as v
};
//# sourceMappingURL=main.88c600c1.js.map
